/* eslint-disable */
// @ts-nocheck -- generated AJV standalone code; never edit directly.
// Regenerate: pnpm --filter @cogo/react-renderer generate:document-model-render-profile-validator
// Sources: @cogo/schema/v4/document-model.cogo.schema.json, @cogo/schema/v4/document-model-react-render-profile.cogo.schema.json
import ajvUcs2LengthModule from "ajv/dist/runtime/ucs2length.js";
const ajvUcs2Length = typeof ajvUcs2LengthModule === "function" ? ajvUcs2LengthModule : ajvUcs2LengthModule.default;
"use strict";
export const validate = validate20;
export default validate20;
const schema31 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"urn:cogo:v4:document-model-react-render-profile","title":"Cogo DocumentModel React Render Profile","description":"Additive closed render profile for deterministic React document rendering. It composes with the extensible DocumentModel base authority without replacing it.","profileVersion":"cogo.document-model-react-render-profile.v1","x-cogo-semantic-constraints":["resource-ids-unique","picture-binaryItemIDRef-exactly-one-resource","chart-series-values-match-categories"],"allOf":[{"$ref":"urn:cogo:v4:document-model"},{"type":"object","properties":{"pages":{"type":"array","items":{"type":"object","properties":{"nodes":{"type":"array","items":{"oneOf":[{"$ref":"#/$defs/ParagraphNode"},{"$ref":"#/$defs/PageNumberNode"},{"$ref":"#/$defs/TableNode"},{"$ref":"#/$defs/PictureNode"},{"$ref":"#/$defs/ShapeNode"},{"$ref":"#/$defs/ChartNode"}]}}}}}}}],"$defs":{"NodeBase":{"type":"object","required":["kind","id","frame"],"properties":{"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"}}},"Frame":{"type":"object","required":["unit","x","y","width","height"],"additionalProperties":false,"properties":{"unit":{"const":"px"},"x":{"type":"number","minimum":0},"y":{"type":"number","minimum":0},"width":{"type":"number","exclusiveMinimum":0},"height":{"type":"number","exclusiveMinimum":0}}},"HexColor":{"type":"string","pattern":"^#[0-9A-Fa-f]{6}$"},"TextStyle":{"type":"object","additionalProperties":false,"properties":{"fontFamily":{"type":"string","minLength":1},"fontSizePx":{"type":"number","exclusiveMinimum":0},"fontWeight":{"type":"integer","minimum":100,"maximum":900,"multipleOf":100},"fontStyle":{"enum":["normal","italic"]},"color":{"$ref":"#/$defs/HexColor"},"lineHeightPx":{"type":"number","exclusiveMinimum":0},"textAlign":{"enum":["start","center","end","justify"]}}},"ParagraphNode":{"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","text"],"additionalProperties":false,"properties":{"kind":{"const":"paragraph"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"text":{"type":"string"},"style":{"$ref":"#/$defs/TextStyle"}}}]},"PageNumberNode":{"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","text"],"additionalProperties":false,"properties":{"kind":{"const":"page_number"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"text":{"type":"string"},"style":{"$ref":"#/$defs/TextStyle"}}}]},"TableCell":{"type":"object","required":["rowIndex","columnIndex","rowSpan","columnSpan","text"],"additionalProperties":false,"properties":{"rowIndex":{"type":"integer","minimum":0},"columnIndex":{"type":"integer","minimum":0},"rowSpan":{"type":"integer","minimum":1},"columnSpan":{"type":"integer","minimum":1},"text":{"type":"string"},"style":{"$ref":"#/$defs/TextStyle"}}},"TableNode":{"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","rowCount","columnCount","cells"],"additionalProperties":false,"properties":{"kind":{"const":"table"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"rowCount":{"type":"integer","minimum":1},"columnCount":{"type":"integer","minimum":1},"cells":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/TableCell"}}}}]},"PictureNode":{"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","binaryItemIDRef"],"additionalProperties":false,"properties":{"kind":{"const":"picture"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"binaryItemIDRef":{"type":"string","minLength":1}}}]},"ShapeNode":{"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","shapeType","fill","stroke"],"additionalProperties":false,"properties":{"kind":{"const":"shape"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"shapeType":{"enum":["rectangle","ellipse","line"]},"fill":{"type":"object","required":["color","opacity"],"additionalProperties":false,"properties":{"color":{"$ref":"#/$defs/HexColor"},"opacity":{"type":"number","minimum":0,"maximum":1}}},"stroke":{"type":"object","required":["color","widthPx","opacity","dash"],"additionalProperties":false,"properties":{"color":{"$ref":"#/$defs/HexColor"},"widthPx":{"type":"number","exclusiveMinimum":0},"opacity":{"type":"number","minimum":0,"maximum":1},"dash":{"enum":["solid","dash","dot"]}}},"text":{"type":"string"},"style":{"$ref":"#/$defs/TextStyle"}}}]},"ChartNode":{"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","chartData"],"additionalProperties":false,"properties":{"kind":{"const":"chart"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"chartData":{"type":"object","required":["type","categories","series"],"additionalProperties":false,"properties":{"type":{"enum":["bar","line","pie"]},"categories":{"type":"array","items":{"type":"string"}},"series":{"type":"array","items":{"type":"object","required":["name","values"],"additionalProperties":false,"properties":{"name":{"type":"string","minLength":1},"values":{"type":"array","items":{"type":"number"}},"color":{"$ref":"#/$defs/HexColor"}}}}}}}}]}}};
const schema32 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"urn:cogo:v4:document-model","title":"Cogo DocumentModel (v1)","description":"Canonical fixed-page document authority used by production document export writers. Writers must read this model, not sibling evidence files or diagnostic render output.","type":"object","required":["schemaVersion","id","source","pageSetup","pages","resources","renderingProfiles","exportPolicy","integrity"],"additionalProperties":false,"properties":{"schemaVersion":{"const":"cogo.document-model.v1"},"id":{"type":"string","pattern":"^[a-zA-Z0-9][a-zA-Z0-9._:-]*$"},"source":{"type":"object","required":["canonicalInput","sourceSha256"],"additionalProperties":true,"properties":{"canonicalInput":{"enum":["hwpx","docx","pptx","pdf","image","generated"]},"sourcePath":{"type":"string"},"sourceSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"standardBasis":{"type":"string"}}},"sourceImport":{"type":"object","additionalProperties":true,"properties":{"schemaVersion":{"const":"cogo.document-source-import.v1"},"sourceKind":{"enum":["real-source","real-source-derived","generated-control","generated"]},"importTier":{"type":"string"},"importPass":{"type":"boolean"},"sourceRenderer":{"type":"string"},"sourceRendererStatus":{"type":"string"},"sourceRasterReady":{"type":"boolean"}}},"pageSetup":{"type":"object","required":["unit","width","height","margin"],"additionalProperties":true,"properties":{"unit":{"const":"px"},"width":{"type":"number","exclusiveMinimum":0},"height":{"type":"number","exclusiveMinimum":0},"orientation":{"enum":["portrait","landscape","unknown"]},"margin":{"type":"object","required":["left","right","top","bottom"],"additionalProperties":false,"properties":{"left":{"type":"number","minimum":0},"right":{"type":"number","minimum":0},"top":{"type":"number","minimum":0},"bottom":{"type":"number","minimum":0},"header":{"type":"number","minimum":0},"footer":{"type":"number","minimum":0}}}}},"pages":{"type":"array","minItems":1,"items":{"type":"object","required":["id","pageIndex","width","height","nodes"],"additionalProperties":true,"properties":{"id":{"type":"string"},"pageIndex":{"type":"integer","minimum":1},"width":{"type":"number","exclusiveMinimum":0},"height":{"type":"number","exclusiveMinimum":0},"nodes":{"type":"array","items":{"type":"object","required":["id","kind","frame"],"additionalProperties":true,"properties":{"id":{"type":"string"},"kind":{"enum":["paragraph","table","picture","page_number","shape","chart","unknown"]},"text":{"type":"string"},"frame":{"type":"object","required":["unit","x","y","width","height"],"additionalProperties":true,"properties":{"unit":{"const":"px"},"x":{"type":"number"},"y":{"type":"number"},"width":{"type":"number","minimum":0},"height":{"type":"number","minimum":0}}},"sourceTrace":{"type":"object","additionalProperties":true}}}}}}},"resources":{"type":"array","items":{"type":"object","required":["id","href"],"additionalProperties":true,"properties":{"id":{"type":"string"},"href":{"type":"string"},"mediaType":{"type":"string"},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"}}}},"styleCatalog":{"type":"object","description":"Source-derived document style authority, including HWPX fontFace, charPr, paraPr, and borderFill catalogs used by semantic reconstruction renderers.","additionalProperties":true,"properties":{"fontFace":{"type":"object","additionalProperties":true},"charPr":{"type":"object","additionalProperties":true},"paraPr":{"type":"object","additionalProperties":true},"borderFill":{"type":"object","additionalProperties":true}}},"visualLayer":{"type":"object","additionalProperties":true,"properties":{"mode":{"type":"string"},"locked":{"type":"boolean"},"editable":{"type":"boolean"},"resourceCount":{"type":"integer","minimum":0},"exactVisualAuthority":{"type":"string"},"sourceRenderer":{"type":"string"}}},"semanticSignature":{"type":"object","additionalProperties":true,"properties":{"schemaVersion":{"type":"string"},"format":{"enum":["pdf","docx","pptx","hwpx"]},"sourceKind":{"enum":["real-source","real-source-derived","generated-control","generated"]},"importTier":{"type":"string"},"normalizedTextHash":{"type":"string","pattern":"^[0-9a-f]{64}$"},"normalizedTextLength":{"type":"integer","minimum":0},"pageCount":{"type":"integer","minimum":0},"objectCount":{"type":"integer","minimum":0},"packageEntryCount":{"type":"integer","minimum":0}}},"layoutGraphSnapshot":{"type":"object","description":"Embedded HWPX layout graph snapshot used as the authority for semantic HWPX rewrite. Required by HWPX reverse exporters when canonicalInput=hwpx.","additionalProperties":true,"properties":{"schemaVersion":{"const":"cogo.hwpx-layout-graph.v1"},"source":{"type":"object","additionalProperties":true},"pageSetup":{"type":"object","additionalProperties":true},"pages":{"type":"array","items":{"type":"object","additionalProperties":true}},"nodes":{"type":"array","items":{"type":"object","additionalProperties":true}},"resources":{"type":"array","items":{"type":"object","additionalProperties":true}}}},"layoutProfile":{"type":"object","additionalProperties":true,"properties":{"coordinateSystem":{"type":"string"},"visualPreservationLayer":{"type":"string"},"editableSemanticLayer":{"type":"string"}}},"fontPolicy":{"type":"object","additionalProperties":true},"designSystemRefs":{"type":"array","items":{"type":"string"}},"semanticNativeLayer":{"type":"object","required":["schemaVersion","authority","pageCount","nodeCount","kindCounts","tableCount","cellCount","nativeExportRequirements"],"additionalProperties":true,"properties":{"schemaVersion":{"const":"cogo.document-semantic-native-layer.v1"},"authority":{"type":"string","minLength":1},"pageCount":{"type":"integer","minimum":1},"nodeCount":{"type":"integer","minimum":0},"kindCounts":{"type":"object","additionalProperties":{"type":"integer","minimum":0}},"tableCount":{"type":"integer","minimum":0},"rowCount":{"type":"integer","minimum":0},"columnCountMax":{"type":"integer","minimum":0},"cellCount":{"type":"integer","minimum":0},"preserves":{"type":"array","items":{"type":"string"}},"nativeExportRequirements":{"type":"object","required":["pdf","docx","pptx","hwpx"],"additionalProperties":{"type":"array","items":{"type":"string"}}}}},"semanticEditPlan":{"type":"object","additionalProperties":true,"properties":{"schemaVersion":{"const":"cogo.document-semantic-edit-plan.v1"},"operation":{"type":"string"},"authority":{"type":"string"},"targetNodeId":{"type":"string"},"before":{"type":"string"},"after":{"type":"string"},"replacementCount":{"type":"integer","minimum":1}}},"editableExportPolicy":{"type":"object","additionalProperties":true,"properties":{"mode":{"type":"string"},"cogoJsonIsAuthority":{"type":"boolean"},"semanticNativeStructureRequired":{"type":"boolean"},"visualPreservationAllowed":{"type":"boolean"}}},"renderingProfiles":{"type":"array","minItems":3,"items":{"enum":["development-validation","studio-preview","production-export"]},"contains":{"const":"production-export"}},"exportPolicy":{"type":"object","required":["targets","hwpBinaryScope"],"additionalProperties":true,"properties":{"targets":{"type":"array","minItems":1,"items":{"enum":["pdf","docx","pptx","hwpx","xlsx"]}},"hwpBinaryScope":{"const":"excluded"}}},"integrity":{"type":"object","required":["documentModelSha256","pageCount","nodeCount"],"additionalProperties":true,"properties":{"documentModelSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"sourceLayoutGraphSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"layoutGraphSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"pageCount":{"type":"integer","minimum":1},"nodeCount":{"type":"integer","minimum":0},"resourceCount":{"type":"integer","minimum":0}}}}};
const func1 = Object.prototype.hasOwnProperty;
const func2 = ajvUcs2Length;
const pattern4 = new RegExp("^[a-zA-Z0-9][a-zA-Z0-9._:-]*$", "u");
const pattern5 = new RegExp("^[0-9a-f]{64}$", "u");
const schema33 = {"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","text"],"additionalProperties":false,"properties":{"kind":{"const":"paragraph"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"text":{"type":"string"},"style":{"$ref":"#/$defs/TextStyle"}}}]};
const schema35 = {"type":"object","required":["unit","x","y","width","height"],"additionalProperties":false,"properties":{"unit":{"const":"px"},"x":{"type":"number","minimum":0},"y":{"type":"number","minimum":0},"width":{"type":"number","exclusiveMinimum":0},"height":{"type":"number","exclusiveMinimum":0}}};
const schema34 = {"type":"object","required":["kind","id","frame"],"properties":{"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"}}};

function validate22(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate22.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.id === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.frame === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "frame"},message:"must have required property '"+"frame"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func2(data0) < 1){
const err3 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.frame !== undefined){
let data1 = data.frame;
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.unit === undefined){
const err5 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data1.x === undefined){
const err6 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data1.y === undefined){
const err7 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data1.width === undefined){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data1.height === undefined){
const err9 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data1){
if(!(((((key0 === "unit") || (key0 === "x")) || (key0 === "y")) || (key0 === "width")) || (key0 === "height"))){
const err10 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data1.unit !== undefined){
if("px" !== data1.unit){
const err11 = {instancePath:instancePath+"/frame/unit",schemaPath:"#/$defs/Frame/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data1.x !== undefined){
let data3 = data1.x;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 < 0 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data1.y !== undefined){
let data4 = data1.y;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err14 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data1.width !== undefined){
let data5 = data1.width;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 <= 0 || isNaN(data5)){
const err16 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data1.height !== undefined){
let data6 = data1.height;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 <= 0 || isNaN(data6)){
const err18 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
validate22.errors = vErrors;
return errors === 0;
}
validate22.evaluated = {"props":{"id":true,"frame":true},"dynamicProps":false,"dynamicItems":false};

const schema37 = {"type":"object","additionalProperties":false,"properties":{"fontFamily":{"type":"string","minLength":1},"fontSizePx":{"type":"number","exclusiveMinimum":0},"fontWeight":{"type":"integer","minimum":100,"maximum":900,"multipleOf":100},"fontStyle":{"enum":["normal","italic"]},"color":{"$ref":"#/$defs/HexColor"},"lineHeightPx":{"type":"number","exclusiveMinimum":0},"textAlign":{"enum":["start","center","end","justify"]}}};
const schema38 = {"type":"string","pattern":"^#[0-9A-Fa-f]{6}$"};
const pattern11 = new RegExp("^#[0-9A-Fa-f]{6}$", "u");

function validate24(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate24.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(!(((((((key0 === "fontFamily") || (key0 === "fontSizePx")) || (key0 === "fontWeight")) || (key0 === "fontStyle")) || (key0 === "color")) || (key0 === "lineHeightPx")) || (key0 === "textAlign"))){
const err0 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data.fontFamily !== undefined){
let data0 = data.fontFamily;
if(typeof data0 === "string"){
if(func2(data0) < 1){
const err1 = {instancePath:instancePath+"/fontFamily",schemaPath:"#/properties/fontFamily/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
else {
const err2 = {instancePath:instancePath+"/fontFamily",schemaPath:"#/properties/fontFamily/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.fontSizePx !== undefined){
let data1 = data.fontSizePx;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 <= 0 || isNaN(data1)){
const err3 = {instancePath:instancePath+"/fontSizePx",schemaPath:"#/properties/fontSizePx/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/fontSizePx",schemaPath:"#/properties/fontSizePx/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.fontWeight !== undefined){
let data2 = data.fontWeight;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err5 = {instancePath:instancePath+"/fontWeight",schemaPath:"#/properties/fontWeight/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 900 || isNaN(data2)){
const err6 = {instancePath:instancePath+"/fontWeight",schemaPath:"#/properties/fontWeight/maximum",keyword:"maximum",params:{comparison: "<=", limit: 900},message:"must be <= 900"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2 < 100 || isNaN(data2)){
const err7 = {instancePath:instancePath+"/fontWeight",schemaPath:"#/properties/fontWeight/minimum",keyword:"minimum",params:{comparison: ">=", limit: 100},message:"must be >= 100"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
let res0;
if((100 === 0 || (res0 = data2/100, res0 !== parseInt(res0)))){
const err8 = {instancePath:instancePath+"/fontWeight",schemaPath:"#/properties/fontWeight/multipleOf",keyword:"multipleOf",params:{multipleOf: 100},message:"must be multiple of 100"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.fontStyle !== undefined){
let data3 = data.fontStyle;
if(!((data3 === "normal") || (data3 === "italic"))){
const err9 = {instancePath:instancePath+"/fontStyle",schemaPath:"#/properties/fontStyle/enum",keyword:"enum",params:{allowedValues: schema37.properties.fontStyle.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.color !== undefined){
let data4 = data.color;
if(typeof data4 === "string"){
if(!pattern11.test(data4)){
const err10 = {instancePath:instancePath+"/color",schemaPath:"#/$defs/HexColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/color",schemaPath:"#/$defs/HexColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.lineHeightPx !== undefined){
let data5 = data.lineHeightPx;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 <= 0 || isNaN(data5)){
const err12 = {instancePath:instancePath+"/lineHeightPx",schemaPath:"#/properties/lineHeightPx/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/lineHeightPx",schemaPath:"#/properties/lineHeightPx/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.textAlign !== undefined){
let data6 = data.textAlign;
if(!((((data6 === "start") || (data6 === "center")) || (data6 === "end")) || (data6 === "justify"))){
const err14 = {instancePath:instancePath+"/textAlign",schemaPath:"#/properties/textAlign/enum",keyword:"enum",params:{allowedValues: schema37.properties.textAlign.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate24.errors = vErrors;
return errors === 0;
}
validate24.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate21.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate22(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.text === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "text"},message:"must have required property '"+"text"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "kind") || (key0 === "id")) || (key0 === "frame")) || (key0 === "text")) || (key0 === "style"))){
const err2 = {instancePath,schemaPath:"#/allOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.kind !== undefined){
if("paragraph" !== data.kind){
const err3 = {instancePath:instancePath+"/kind",schemaPath:"#/allOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "paragraph"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.frame !== undefined){
let data2 = data.frame;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.unit === undefined){
const err6 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2.x === undefined){
const err7 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2.y === undefined){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data2.width === undefined){
const err9 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2.height === undefined){
const err10 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
for(const key1 in data2){
if(!(((((key1 === "unit") || (key1 === "x")) || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err11 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data2.unit !== undefined){
if("px" !== data2.unit){
const err12 = {instancePath:instancePath+"/frame/unit",schemaPath:"#/$defs/Frame/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data2.x !== undefined){
let data4 = data2.x;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err13 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.y !== undefined){
let data5 = data2.y;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 0 || isNaN(data5)){
const err15 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.width !== undefined){
let data6 = data2.width;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 <= 0 || isNaN(data6)){
const err17 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data2.height !== undefined){
let data7 = data2.height;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 <= 0 || isNaN(data7)){
const err19 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.text !== undefined){
if(typeof data.text !== "string"){
const err22 = {instancePath:instancePath+"/text",schemaPath:"#/allOf/1/properties/text/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.style !== undefined){
if(!(validate24(data.style, {instancePath:instancePath+"/style",parentData:data,parentDataProperty:"style",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
}
}
validate21.errors = vErrors;
return errors === 0;
}
validate21.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema39 = {"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","text"],"additionalProperties":false,"properties":{"kind":{"const":"page_number"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"text":{"type":"string"},"style":{"$ref":"#/$defs/TextStyle"}}}]};

function validate27(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate27.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate22(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.text === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "text"},message:"must have required property '"+"text"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "kind") || (key0 === "id")) || (key0 === "frame")) || (key0 === "text")) || (key0 === "style"))){
const err2 = {instancePath,schemaPath:"#/allOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.kind !== undefined){
if("page_number" !== data.kind){
const err3 = {instancePath:instancePath+"/kind",schemaPath:"#/allOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "page_number"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.frame !== undefined){
let data2 = data.frame;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.unit === undefined){
const err6 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2.x === undefined){
const err7 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2.y === undefined){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data2.width === undefined){
const err9 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2.height === undefined){
const err10 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
for(const key1 in data2){
if(!(((((key1 === "unit") || (key1 === "x")) || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err11 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data2.unit !== undefined){
if("px" !== data2.unit){
const err12 = {instancePath:instancePath+"/frame/unit",schemaPath:"#/$defs/Frame/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data2.x !== undefined){
let data4 = data2.x;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err13 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.y !== undefined){
let data5 = data2.y;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 0 || isNaN(data5)){
const err15 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.width !== undefined){
let data6 = data2.width;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 <= 0 || isNaN(data6)){
const err17 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data2.height !== undefined){
let data7 = data2.height;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 <= 0 || isNaN(data7)){
const err19 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.text !== undefined){
if(typeof data.text !== "string"){
const err22 = {instancePath:instancePath+"/text",schemaPath:"#/allOf/1/properties/text/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.style !== undefined){
if(!(validate24(data.style, {instancePath:instancePath+"/style",parentData:data,parentDataProperty:"style",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
}
}
validate27.errors = vErrors;
return errors === 0;
}
validate27.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema41 = {"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","rowCount","columnCount","cells"],"additionalProperties":false,"properties":{"kind":{"const":"table"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"rowCount":{"type":"integer","minimum":1},"columnCount":{"type":"integer","minimum":1},"cells":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/TableCell"}}}}]};
const schema43 = {"type":"object","required":["rowIndex","columnIndex","rowSpan","columnSpan","text"],"additionalProperties":false,"properties":{"rowIndex":{"type":"integer","minimum":0},"columnIndex":{"type":"integer","minimum":0},"rowSpan":{"type":"integer","minimum":1},"columnSpan":{"type":"integer","minimum":1},"text":{"type":"string"},"style":{"$ref":"#/$defs/TextStyle"}}};

function validate33(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate33.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.rowIndex === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rowIndex"},message:"must have required property '"+"rowIndex"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.columnIndex === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "columnIndex"},message:"must have required property '"+"columnIndex"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.rowSpan === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rowSpan"},message:"must have required property '"+"rowSpan"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.columnSpan === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "columnSpan"},message:"must have required property '"+"columnSpan"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.text === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "text"},message:"must have required property '"+"text"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "rowIndex") || (key0 === "columnIndex")) || (key0 === "rowSpan")) || (key0 === "columnSpan")) || (key0 === "text")) || (key0 === "style"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.rowIndex !== undefined){
let data0 = data.rowIndex;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/rowIndex",schemaPath:"#/properties/rowIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 0 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/rowIndex",schemaPath:"#/properties/rowIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.columnIndex !== undefined){
let data1 = data.columnIndex;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err8 = {instancePath:instancePath+"/columnIndex",schemaPath:"#/properties/columnIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 < 0 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/columnIndex",schemaPath:"#/properties/columnIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
if(data.rowSpan !== undefined){
let data2 = data.rowSpan;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err10 = {instancePath:instancePath+"/rowSpan",schemaPath:"#/properties/rowSpan/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 < 1 || isNaN(data2)){
const err11 = {instancePath:instancePath+"/rowSpan",schemaPath:"#/properties/rowSpan/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
if(data.columnSpan !== undefined){
let data3 = data.columnSpan;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err12 = {instancePath:instancePath+"/columnSpan",schemaPath:"#/properties/columnSpan/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 < 1 || isNaN(data3)){
const err13 = {instancePath:instancePath+"/columnSpan",schemaPath:"#/properties/columnSpan/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.text !== undefined){
if(typeof data.text !== "string"){
const err14 = {instancePath:instancePath+"/text",schemaPath:"#/properties/text/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.style !== undefined){
if(!(validate24(data.style, {instancePath:instancePath+"/style",parentData:data,parentDataProperty:"style",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate33.errors = vErrors;
return errors === 0;
}
validate33.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate31(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate31.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate22(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.rowCount === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "rowCount"},message:"must have required property '"+"rowCount"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.columnCount === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "columnCount"},message:"must have required property '"+"columnCount"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.cells === undefined){
const err3 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "cells"},message:"must have required property '"+"cells"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "kind") || (key0 === "id")) || (key0 === "frame")) || (key0 === "rowCount")) || (key0 === "columnCount")) || (key0 === "cells"))){
const err4 = {instancePath,schemaPath:"#/allOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.kind !== undefined){
if("table" !== data.kind){
const err5 = {instancePath:instancePath+"/kind",schemaPath:"#/allOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "table"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.frame !== undefined){
let data2 = data.frame;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.unit === undefined){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data2.x === undefined){
const err9 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2.y === undefined){
const err10 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data2.width === undefined){
const err11 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2.height === undefined){
const err12 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data2){
if(!(((((key1 === "unit") || (key1 === "x")) || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err13 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data2.unit !== undefined){
if("px" !== data2.unit){
const err14 = {instancePath:instancePath+"/frame/unit",schemaPath:"#/$defs/Frame/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.x !== undefined){
let data4 = data2.x;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err15 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.y !== undefined){
let data5 = data2.y;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 0 || isNaN(data5)){
const err17 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data2.width !== undefined){
let data6 = data2.width;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 <= 0 || isNaN(data6)){
const err19 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data2.height !== undefined){
let data7 = data2.height;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 <= 0 || isNaN(data7)){
const err21 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.rowCount !== undefined){
let data8 = data.rowCount;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err24 = {instancePath:instancePath+"/rowCount",schemaPath:"#/allOf/1/properties/rowCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 < 1 || isNaN(data8)){
const err25 = {instancePath:instancePath+"/rowCount",schemaPath:"#/allOf/1/properties/rowCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
if(data.columnCount !== undefined){
let data9 = data.columnCount;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err26 = {instancePath:instancePath+"/columnCount",schemaPath:"#/allOf/1/properties/columnCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 < 1 || isNaN(data9)){
const err27 = {instancePath:instancePath+"/columnCount",schemaPath:"#/allOf/1/properties/columnCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
if(data.cells !== undefined){
let data10 = data.cells;
if(Array.isArray(data10)){
if(data10.length < 1){
const err28 = {instancePath:instancePath+"/cells",schemaPath:"#/allOf/1/properties/cells/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
const len0 = data10.length;
for(let i0=0; i0<len0; i0++){
if(!(validate33(data10[i0], {instancePath:instancePath+"/cells/" + i0,parentData:data10,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate33.errors : vErrors.concat(validate33.errors);
errors = vErrors.length;
}
}
}
else {
const err29 = {instancePath:instancePath+"/cells",schemaPath:"#/allOf/1/properties/cells/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
validate31.errors = vErrors;
return errors === 0;
}
validate31.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema44 = {"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","binaryItemIDRef"],"additionalProperties":false,"properties":{"kind":{"const":"picture"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"binaryItemIDRef":{"type":"string","minLength":1}}}]};

function validate37(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate37.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate22(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.binaryItemIDRef === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "binaryItemIDRef"},message:"must have required property '"+"binaryItemIDRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "kind") || (key0 === "id")) || (key0 === "frame")) || (key0 === "binaryItemIDRef"))){
const err2 = {instancePath,schemaPath:"#/allOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.kind !== undefined){
if("picture" !== data.kind){
const err3 = {instancePath:instancePath+"/kind",schemaPath:"#/allOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "picture"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.frame !== undefined){
let data2 = data.frame;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.unit === undefined){
const err6 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2.x === undefined){
const err7 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2.y === undefined){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data2.width === undefined){
const err9 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2.height === undefined){
const err10 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
for(const key1 in data2){
if(!(((((key1 === "unit") || (key1 === "x")) || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err11 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data2.unit !== undefined){
if("px" !== data2.unit){
const err12 = {instancePath:instancePath+"/frame/unit",schemaPath:"#/$defs/Frame/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data2.x !== undefined){
let data4 = data2.x;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err13 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.y !== undefined){
let data5 = data2.y;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 0 || isNaN(data5)){
const err15 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.width !== undefined){
let data6 = data2.width;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 <= 0 || isNaN(data6)){
const err17 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data2.height !== undefined){
let data7 = data2.height;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 <= 0 || isNaN(data7)){
const err19 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.binaryItemIDRef !== undefined){
let data8 = data.binaryItemIDRef;
if(typeof data8 === "string"){
if(func2(data8) < 1){
const err22 = {instancePath:instancePath+"/binaryItemIDRef",schemaPath:"#/allOf/1/properties/binaryItemIDRef/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/binaryItemIDRef",schemaPath:"#/allOf/1/properties/binaryItemIDRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
validate37.errors = vErrors;
return errors === 0;
}
validate37.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema46 = {"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","shapeType","fill","stroke"],"additionalProperties":false,"properties":{"kind":{"const":"shape"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"shapeType":{"enum":["rectangle","ellipse","line"]},"fill":{"type":"object","required":["color","opacity"],"additionalProperties":false,"properties":{"color":{"$ref":"#/$defs/HexColor"},"opacity":{"type":"number","minimum":0,"maximum":1}}},"stroke":{"type":"object","required":["color","widthPx","opacity","dash"],"additionalProperties":false,"properties":{"color":{"$ref":"#/$defs/HexColor"},"widthPx":{"type":"number","exclusiveMinimum":0},"opacity":{"type":"number","minimum":0,"maximum":1},"dash":{"enum":["solid","dash","dot"]}}},"text":{"type":"string"},"style":{"$ref":"#/$defs/TextStyle"}}}]};

function validate40(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate40.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate22(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.shapeType === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "shapeType"},message:"must have required property '"+"shapeType"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.fill === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "fill"},message:"must have required property '"+"fill"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.stroke === undefined){
const err3 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "stroke"},message:"must have required property '"+"stroke"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "kind") || (key0 === "id")) || (key0 === "frame")) || (key0 === "shapeType")) || (key0 === "fill")) || (key0 === "stroke")) || (key0 === "text")) || (key0 === "style"))){
const err4 = {instancePath,schemaPath:"#/allOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.kind !== undefined){
if("shape" !== data.kind){
const err5 = {instancePath:instancePath+"/kind",schemaPath:"#/allOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "shape"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.frame !== undefined){
let data2 = data.frame;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.unit === undefined){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data2.x === undefined){
const err9 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2.y === undefined){
const err10 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data2.width === undefined){
const err11 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2.height === undefined){
const err12 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data2){
if(!(((((key1 === "unit") || (key1 === "x")) || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err13 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data2.unit !== undefined){
if("px" !== data2.unit){
const err14 = {instancePath:instancePath+"/frame/unit",schemaPath:"#/$defs/Frame/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.x !== undefined){
let data4 = data2.x;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err15 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.y !== undefined){
let data5 = data2.y;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 0 || isNaN(data5)){
const err17 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data2.width !== undefined){
let data6 = data2.width;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 <= 0 || isNaN(data6)){
const err19 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data2.height !== undefined){
let data7 = data2.height;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 <= 0 || isNaN(data7)){
const err21 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.shapeType !== undefined){
let data8 = data.shapeType;
if(!(((data8 === "rectangle") || (data8 === "ellipse")) || (data8 === "line"))){
const err24 = {instancePath:instancePath+"/shapeType",schemaPath:"#/allOf/1/properties/shapeType/enum",keyword:"enum",params:{allowedValues: schema46.allOf[1].properties.shapeType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.fill !== undefined){
let data9 = data.fill;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(data9.color === undefined){
const err25 = {instancePath:instancePath+"/fill",schemaPath:"#/allOf/1/properties/fill/required",keyword:"required",params:{missingProperty: "color"},message:"must have required property '"+"color"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data9.opacity === undefined){
const err26 = {instancePath:instancePath+"/fill",schemaPath:"#/allOf/1/properties/fill/required",keyword:"required",params:{missingProperty: "opacity"},message:"must have required property '"+"opacity"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
for(const key2 in data9){
if(!((key2 === "color") || (key2 === "opacity"))){
const err27 = {instancePath:instancePath+"/fill",schemaPath:"#/allOf/1/properties/fill/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data9.color !== undefined){
let data10 = data9.color;
if(typeof data10 === "string"){
if(!pattern11.test(data10)){
const err28 = {instancePath:instancePath+"/fill/color",schemaPath:"#/$defs/HexColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/fill/color",schemaPath:"#/$defs/HexColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data9.opacity !== undefined){
let data11 = data9.opacity;
if((typeof data11 == "number") && (isFinite(data11))){
if(data11 > 1 || isNaN(data11)){
const err30 = {instancePath:instancePath+"/fill/opacity",schemaPath:"#/allOf/1/properties/fill/properties/opacity/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data11 < 0 || isNaN(data11)){
const err31 = {instancePath:instancePath+"/fill/opacity",schemaPath:"#/allOf/1/properties/fill/properties/opacity/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
else {
const err32 = {instancePath:instancePath+"/fill/opacity",schemaPath:"#/allOf/1/properties/fill/properties/opacity/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
else {
const err33 = {instancePath:instancePath+"/fill",schemaPath:"#/allOf/1/properties/fill/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.stroke !== undefined){
let data12 = data.stroke;
if(data12 && typeof data12 == "object" && !Array.isArray(data12)){
if(data12.color === undefined){
const err34 = {instancePath:instancePath+"/stroke",schemaPath:"#/allOf/1/properties/stroke/required",keyword:"required",params:{missingProperty: "color"},message:"must have required property '"+"color"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data12.widthPx === undefined){
const err35 = {instancePath:instancePath+"/stroke",schemaPath:"#/allOf/1/properties/stroke/required",keyword:"required",params:{missingProperty: "widthPx"},message:"must have required property '"+"widthPx"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data12.opacity === undefined){
const err36 = {instancePath:instancePath+"/stroke",schemaPath:"#/allOf/1/properties/stroke/required",keyword:"required",params:{missingProperty: "opacity"},message:"must have required property '"+"opacity"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data12.dash === undefined){
const err37 = {instancePath:instancePath+"/stroke",schemaPath:"#/allOf/1/properties/stroke/required",keyword:"required",params:{missingProperty: "dash"},message:"must have required property '"+"dash"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
for(const key3 in data12){
if(!((((key3 === "color") || (key3 === "widthPx")) || (key3 === "opacity")) || (key3 === "dash"))){
const err38 = {instancePath:instancePath+"/stroke",schemaPath:"#/allOf/1/properties/stroke/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data12.color !== undefined){
let data13 = data12.color;
if(typeof data13 === "string"){
if(!pattern11.test(data13)){
const err39 = {instancePath:instancePath+"/stroke/color",schemaPath:"#/$defs/HexColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
else {
const err40 = {instancePath:instancePath+"/stroke/color",schemaPath:"#/$defs/HexColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data12.widthPx !== undefined){
let data14 = data12.widthPx;
if((typeof data14 == "number") && (isFinite(data14))){
if(data14 <= 0 || isNaN(data14)){
const err41 = {instancePath:instancePath+"/stroke/widthPx",schemaPath:"#/allOf/1/properties/stroke/properties/widthPx/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
else {
const err42 = {instancePath:instancePath+"/stroke/widthPx",schemaPath:"#/allOf/1/properties/stroke/properties/widthPx/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data12.opacity !== undefined){
let data15 = data12.opacity;
if((typeof data15 == "number") && (isFinite(data15))){
if(data15 > 1 || isNaN(data15)){
const err43 = {instancePath:instancePath+"/stroke/opacity",schemaPath:"#/allOf/1/properties/stroke/properties/opacity/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if(data15 < 0 || isNaN(data15)){
const err44 = {instancePath:instancePath+"/stroke/opacity",schemaPath:"#/allOf/1/properties/stroke/properties/opacity/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {instancePath:instancePath+"/stroke/opacity",schemaPath:"#/allOf/1/properties/stroke/properties/opacity/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data12.dash !== undefined){
let data16 = data12.dash;
if(!(((data16 === "solid") || (data16 === "dash")) || (data16 === "dot"))){
const err46 = {instancePath:instancePath+"/stroke/dash",schemaPath:"#/allOf/1/properties/stroke/properties/dash/enum",keyword:"enum",params:{allowedValues: schema46.allOf[1].properties.stroke.properties.dash.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
}
else {
const err47 = {instancePath:instancePath+"/stroke",schemaPath:"#/allOf/1/properties/stroke/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data.text !== undefined){
if(typeof data.text !== "string"){
const err48 = {instancePath:instancePath+"/text",schemaPath:"#/allOf/1/properties/text/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data.style !== undefined){
if(!(validate24(data.style, {instancePath:instancePath+"/style",parentData:data,parentDataProperty:"style",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
}
}
validate40.errors = vErrors;
return errors === 0;
}
validate40.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema50 = {"allOf":[{"$ref":"#/$defs/NodeBase"},{"required":["kind","chartData"],"additionalProperties":false,"properties":{"kind":{"const":"chart"},"id":{"type":"string","minLength":1},"frame":{"$ref":"#/$defs/Frame"},"chartData":{"type":"object","required":["type","categories","series"],"additionalProperties":false,"properties":{"type":{"enum":["bar","line","pie"]},"categories":{"type":"array","items":{"type":"string"}},"series":{"type":"array","items":{"type":"object","required":["name","values"],"additionalProperties":false,"properties":{"name":{"type":"string","minLength":1},"values":{"type":"array","items":{"type":"number"}},"color":{"$ref":"#/$defs/HexColor"}}}}}}}}]};

function validate44(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate44.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate22(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.chartData === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "chartData"},message:"must have required property '"+"chartData"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "kind") || (key0 === "id")) || (key0 === "frame")) || (key0 === "chartData"))){
const err2 = {instancePath,schemaPath:"#/allOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.kind !== undefined){
if("chart" !== data.kind){
const err3 = {instancePath:instancePath+"/kind",schemaPath:"#/allOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "chart"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/allOf/1/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.frame !== undefined){
let data2 = data.frame;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.unit === undefined){
const err6 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2.x === undefined){
const err7 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2.y === undefined){
const err8 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data2.width === undefined){
const err9 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2.height === undefined){
const err10 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
for(const key1 in data2){
if(!(((((key1 === "unit") || (key1 === "x")) || (key1 === "y")) || (key1 === "width")) || (key1 === "height"))){
const err11 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data2.unit !== undefined){
if("px" !== data2.unit){
const err12 = {instancePath:instancePath+"/frame/unit",schemaPath:"#/$defs/Frame/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data2.x !== undefined){
let data4 = data2.x;
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err13 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/frame/x",schemaPath:"#/$defs/Frame/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.y !== undefined){
let data5 = data2.y;
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 0 || isNaN(data5)){
const err15 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/frame/y",schemaPath:"#/$defs/Frame/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.width !== undefined){
let data6 = data2.width;
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 <= 0 || isNaN(data6)){
const err17 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/frame/width",schemaPath:"#/$defs/Frame/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data2.height !== undefined){
let data7 = data2.height;
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 <= 0 || isNaN(data7)){
const err19 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/frame/height",schemaPath:"#/$defs/Frame/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/frame",schemaPath:"#/$defs/Frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.chartData !== undefined){
let data8 = data.chartData;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.type === undefined){
const err22 = {instancePath:instancePath+"/chartData",schemaPath:"#/allOf/1/properties/chartData/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data8.categories === undefined){
const err23 = {instancePath:instancePath+"/chartData",schemaPath:"#/allOf/1/properties/chartData/required",keyword:"required",params:{missingProperty: "categories"},message:"must have required property '"+"categories"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data8.series === undefined){
const err24 = {instancePath:instancePath+"/chartData",schemaPath:"#/allOf/1/properties/chartData/required",keyword:"required",params:{missingProperty: "series"},message:"must have required property '"+"series"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
for(const key2 in data8){
if(!(((key2 === "type") || (key2 === "categories")) || (key2 === "series"))){
const err25 = {instancePath:instancePath+"/chartData",schemaPath:"#/allOf/1/properties/chartData/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data8.type !== undefined){
let data9 = data8.type;
if(!(((data9 === "bar") || (data9 === "line")) || (data9 === "pie"))){
const err26 = {instancePath:instancePath+"/chartData/type",schemaPath:"#/allOf/1/properties/chartData/properties/type/enum",keyword:"enum",params:{allowedValues: schema50.allOf[1].properties.chartData.properties.type.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data8.categories !== undefined){
let data10 = data8.categories;
if(Array.isArray(data10)){
const len0 = data10.length;
for(let i0=0; i0<len0; i0++){
if(typeof data10[i0] !== "string"){
const err27 = {instancePath:instancePath+"/chartData/categories/" + i0,schemaPath:"#/allOf/1/properties/chartData/properties/categories/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath:instancePath+"/chartData/categories",schemaPath:"#/allOf/1/properties/chartData/properties/categories/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data8.series !== undefined){
let data12 = data8.series;
if(Array.isArray(data12)){
const len1 = data12.length;
for(let i1=0; i1<len1; i1++){
let data13 = data12[i1];
if(data13 && typeof data13 == "object" && !Array.isArray(data13)){
if(data13.name === undefined){
const err29 = {instancePath:instancePath+"/chartData/series/" + i1,schemaPath:"#/allOf/1/properties/chartData/properties/series/items/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data13.values === undefined){
const err30 = {instancePath:instancePath+"/chartData/series/" + i1,schemaPath:"#/allOf/1/properties/chartData/properties/series/items/required",keyword:"required",params:{missingProperty: "values"},message:"must have required property '"+"values"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
for(const key3 in data13){
if(!(((key3 === "name") || (key3 === "values")) || (key3 === "color"))){
const err31 = {instancePath:instancePath+"/chartData/series/" + i1,schemaPath:"#/allOf/1/properties/chartData/properties/series/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data13.name !== undefined){
let data14 = data13.name;
if(typeof data14 === "string"){
if(func2(data14) < 1){
const err32 = {instancePath:instancePath+"/chartData/series/" + i1+"/name",schemaPath:"#/allOf/1/properties/chartData/properties/series/items/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/chartData/series/" + i1+"/name",schemaPath:"#/allOf/1/properties/chartData/properties/series/items/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data13.values !== undefined){
let data15 = data13.values;
if(Array.isArray(data15)){
const len2 = data15.length;
for(let i2=0; i2<len2; i2++){
let data16 = data15[i2];
if(!((typeof data16 == "number") && (isFinite(data16)))){
const err34 = {instancePath:instancePath+"/chartData/series/" + i1+"/values/" + i2,schemaPath:"#/allOf/1/properties/chartData/properties/series/items/properties/values/items/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath:instancePath+"/chartData/series/" + i1+"/values",schemaPath:"#/allOf/1/properties/chartData/properties/series/items/properties/values/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data13.color !== undefined){
let data17 = data13.color;
if(typeof data17 === "string"){
if(!pattern11.test(data17)){
const err36 = {instancePath:instancePath+"/chartData/series/" + i1+"/color",schemaPath:"#/$defs/HexColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9A-Fa-f]{6}$"},message:"must match pattern \""+"^#[0-9A-Fa-f]{6}$"+"\""};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/chartData/series/" + i1+"/color",schemaPath:"#/$defs/HexColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
else {
const err38 = {instancePath:instancePath+"/chartData/series/" + i1,schemaPath:"#/allOf/1/properties/chartData/properties/series/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
}
else {
const err39 = {instancePath:instancePath+"/chartData/series",schemaPath:"#/allOf/1/properties/chartData/properties/series/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
else {
const err40 = {instancePath:instancePath+"/chartData",schemaPath:"#/allOf/1/properties/chartData/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
validate44.errors = vErrors;
return errors === 0;
}
validate44.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="urn:cogo:v4:document-model-react-render-profile" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate20.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schemaVersion === undefined){
const err0 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.id === undefined){
const err1 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.source === undefined){
const err2 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.pageSetup === undefined){
const err3 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "pageSetup"},message:"must have required property '"+"pageSetup"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.pages === undefined){
const err4 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "pages"},message:"must have required property '"+"pages"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.resources === undefined){
const err5 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "resources"},message:"must have required property '"+"resources"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.renderingProfiles === undefined){
const err6 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "renderingProfiles"},message:"must have required property '"+"renderingProfiles"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.exportPolicy === undefined){
const err7 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "exportPolicy"},message:"must have required property '"+"exportPolicy"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.integrity === undefined){
const err8 = {instancePath,schemaPath:"urn:cogo:v4:document-model/required",keyword:"required",params:{missingProperty: "integrity"},message:"must have required property '"+"integrity"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema32.properties, key0))){
const err9 = {instancePath,schemaPath:"urn:cogo:v4:document-model/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.schemaVersion !== undefined){
if("cogo.document-model.v1" !== data.schemaVersion){
const err10 = {instancePath:instancePath+"/schemaVersion",schemaPath:"urn:cogo:v4:document-model/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.document-model.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(!pattern4.test(data1)){
const err11 = {instancePath:instancePath+"/id",schemaPath:"urn:cogo:v4:document-model/properties/id/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9][a-zA-Z0-9._:-]*$"},message:"must match pattern \""+"^[a-zA-Z0-9][a-zA-Z0-9._:-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/id",schemaPath:"urn:cogo:v4:document-model/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.source !== undefined){
let data2 = data.source;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.canonicalInput === undefined){
const err13 = {instancePath:instancePath+"/source",schemaPath:"urn:cogo:v4:document-model/properties/source/required",keyword:"required",params:{missingProperty: "canonicalInput"},message:"must have required property '"+"canonicalInput"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2.sourceSha256 === undefined){
const err14 = {instancePath:instancePath+"/source",schemaPath:"urn:cogo:v4:document-model/properties/source/required",keyword:"required",params:{missingProperty: "sourceSha256"},message:"must have required property '"+"sourceSha256"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data2.canonicalInput !== undefined){
let data3 = data2.canonicalInput;
if(!((((((data3 === "hwpx") || (data3 === "docx")) || (data3 === "pptx")) || (data3 === "pdf")) || (data3 === "image")) || (data3 === "generated"))){
const err15 = {instancePath:instancePath+"/source/canonicalInput",schemaPath:"urn:cogo:v4:document-model/properties/source/properties/canonicalInput/enum",keyword:"enum",params:{allowedValues: schema32.properties.source.properties.canonicalInput.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data2.sourcePath !== undefined){
if(typeof data2.sourcePath !== "string"){
const err16 = {instancePath:instancePath+"/source/sourcePath",schemaPath:"urn:cogo:v4:document-model/properties/source/properties/sourcePath/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.sourceSha256 !== undefined){
let data5 = data2.sourceSha256;
if(typeof data5 === "string"){
if(!pattern5.test(data5)){
const err17 = {instancePath:instancePath+"/source/sourceSha256",schemaPath:"urn:cogo:v4:document-model/properties/source/properties/sourceSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/source/sourceSha256",schemaPath:"urn:cogo:v4:document-model/properties/source/properties/sourceSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data2.standardBasis !== undefined){
if(typeof data2.standardBasis !== "string"){
const err19 = {instancePath:instancePath+"/source/standardBasis",schemaPath:"urn:cogo:v4:document-model/properties/source/properties/standardBasis/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath:instancePath+"/source",schemaPath:"urn:cogo:v4:document-model/properties/source/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.sourceImport !== undefined){
let data7 = data.sourceImport;
if(data7 && typeof data7 == "object" && !Array.isArray(data7)){
if(data7.schemaVersion !== undefined){
if("cogo.document-source-import.v1" !== data7.schemaVersion){
const err21 = {instancePath:instancePath+"/sourceImport/schemaVersion",schemaPath:"urn:cogo:v4:document-model/properties/sourceImport/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.document-source-import.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data7.sourceKind !== undefined){
let data9 = data7.sourceKind;
if(!((((data9 === "real-source") || (data9 === "real-source-derived")) || (data9 === "generated-control")) || (data9 === "generated"))){
const err22 = {instancePath:instancePath+"/sourceImport/sourceKind",schemaPath:"urn:cogo:v4:document-model/properties/sourceImport/properties/sourceKind/enum",keyword:"enum",params:{allowedValues: schema32.properties.sourceImport.properties.sourceKind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data7.importTier !== undefined){
if(typeof data7.importTier !== "string"){
const err23 = {instancePath:instancePath+"/sourceImport/importTier",schemaPath:"urn:cogo:v4:document-model/properties/sourceImport/properties/importTier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data7.importPass !== undefined){
if(typeof data7.importPass !== "boolean"){
const err24 = {instancePath:instancePath+"/sourceImport/importPass",schemaPath:"urn:cogo:v4:document-model/properties/sourceImport/properties/importPass/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data7.sourceRenderer !== undefined){
if(typeof data7.sourceRenderer !== "string"){
const err25 = {instancePath:instancePath+"/sourceImport/sourceRenderer",schemaPath:"urn:cogo:v4:document-model/properties/sourceImport/properties/sourceRenderer/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data7.sourceRendererStatus !== undefined){
if(typeof data7.sourceRendererStatus !== "string"){
const err26 = {instancePath:instancePath+"/sourceImport/sourceRendererStatus",schemaPath:"urn:cogo:v4:document-model/properties/sourceImport/properties/sourceRendererStatus/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data7.sourceRasterReady !== undefined){
if(typeof data7.sourceRasterReady !== "boolean"){
const err27 = {instancePath:instancePath+"/sourceImport/sourceRasterReady",schemaPath:"urn:cogo:v4:document-model/properties/sourceImport/properties/sourceRasterReady/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
else {
const err28 = {instancePath:instancePath+"/sourceImport",schemaPath:"urn:cogo:v4:document-model/properties/sourceImport/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.pageSetup !== undefined){
let data15 = data.pageSetup;
if(data15 && typeof data15 == "object" && !Array.isArray(data15)){
if(data15.unit === undefined){
const err29 = {instancePath:instancePath+"/pageSetup",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data15.width === undefined){
const err30 = {instancePath:instancePath+"/pageSetup",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data15.height === undefined){
const err31 = {instancePath:instancePath+"/pageSetup",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data15.margin === undefined){
const err32 = {instancePath:instancePath+"/pageSetup",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/required",keyword:"required",params:{missingProperty: "margin"},message:"must have required property '"+"margin"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data15.unit !== undefined){
if("px" !== data15.unit){
const err33 = {instancePath:instancePath+"/pageSetup/unit",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data15.width !== undefined){
let data17 = data15.width;
if((typeof data17 == "number") && (isFinite(data17))){
if(data17 <= 0 || isNaN(data17)){
const err34 = {instancePath:instancePath+"/pageSetup/width",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/pageSetup/width",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data15.height !== undefined){
let data18 = data15.height;
if((typeof data18 == "number") && (isFinite(data18))){
if(data18 <= 0 || isNaN(data18)){
const err36 = {instancePath:instancePath+"/pageSetup/height",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/pageSetup/height",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data15.orientation !== undefined){
let data19 = data15.orientation;
if(!(((data19 === "portrait") || (data19 === "landscape")) || (data19 === "unknown"))){
const err38 = {instancePath:instancePath+"/pageSetup/orientation",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/orientation/enum",keyword:"enum",params:{allowedValues: schema32.properties.pageSetup.properties.orientation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data15.margin !== undefined){
let data20 = data15.margin;
if(data20 && typeof data20 == "object" && !Array.isArray(data20)){
if(data20.left === undefined){
const err39 = {instancePath:instancePath+"/pageSetup/margin",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/required",keyword:"required",params:{missingProperty: "left"},message:"must have required property '"+"left"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data20.right === undefined){
const err40 = {instancePath:instancePath+"/pageSetup/margin",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/required",keyword:"required",params:{missingProperty: "right"},message:"must have required property '"+"right"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data20.top === undefined){
const err41 = {instancePath:instancePath+"/pageSetup/margin",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/required",keyword:"required",params:{missingProperty: "top"},message:"must have required property '"+"top"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data20.bottom === undefined){
const err42 = {instancePath:instancePath+"/pageSetup/margin",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/required",keyword:"required",params:{missingProperty: "bottom"},message:"must have required property '"+"bottom"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
for(const key1 in data20){
if(!((((((key1 === "left") || (key1 === "right")) || (key1 === "top")) || (key1 === "bottom")) || (key1 === "header")) || (key1 === "footer"))){
const err43 = {instancePath:instancePath+"/pageSetup/margin",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data20.left !== undefined){
let data21 = data20.left;
if((typeof data21 == "number") && (isFinite(data21))){
if(data21 < 0 || isNaN(data21)){
const err44 = {instancePath:instancePath+"/pageSetup/margin/left",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/left/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {instancePath:instancePath+"/pageSetup/margin/left",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/left/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data20.right !== undefined){
let data22 = data20.right;
if((typeof data22 == "number") && (isFinite(data22))){
if(data22 < 0 || isNaN(data22)){
const err46 = {instancePath:instancePath+"/pageSetup/margin/right",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/right/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {instancePath:instancePath+"/pageSetup/margin/right",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/right/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data20.top !== undefined){
let data23 = data20.top;
if((typeof data23 == "number") && (isFinite(data23))){
if(data23 < 0 || isNaN(data23)){
const err48 = {instancePath:instancePath+"/pageSetup/margin/top",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/top/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
else {
const err49 = {instancePath:instancePath+"/pageSetup/margin/top",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/top/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data20.bottom !== undefined){
let data24 = data20.bottom;
if((typeof data24 == "number") && (isFinite(data24))){
if(data24 < 0 || isNaN(data24)){
const err50 = {instancePath:instancePath+"/pageSetup/margin/bottom",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/bottom/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
else {
const err51 = {instancePath:instancePath+"/pageSetup/margin/bottom",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/bottom/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data20.header !== undefined){
let data25 = data20.header;
if((typeof data25 == "number") && (isFinite(data25))){
if(data25 < 0 || isNaN(data25)){
const err52 = {instancePath:instancePath+"/pageSetup/margin/header",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/header/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
else {
const err53 = {instancePath:instancePath+"/pageSetup/margin/header",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/header/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
if(data20.footer !== undefined){
let data26 = data20.footer;
if((typeof data26 == "number") && (isFinite(data26))){
if(data26 < 0 || isNaN(data26)){
const err54 = {instancePath:instancePath+"/pageSetup/margin/footer",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/footer/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
else {
const err55 = {instancePath:instancePath+"/pageSetup/margin/footer",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/properties/footer/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
}
else {
const err56 = {instancePath:instancePath+"/pageSetup/margin",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/properties/margin/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
}
else {
const err57 = {instancePath:instancePath+"/pageSetup",schemaPath:"urn:cogo:v4:document-model/properties/pageSetup/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
if(data.pages !== undefined){
let data27 = data.pages;
if(Array.isArray(data27)){
if(data27.length < 1){
const err58 = {instancePath:instancePath+"/pages",schemaPath:"urn:cogo:v4:document-model/properties/pages/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
const len0 = data27.length;
for(let i0=0; i0<len0; i0++){
let data28 = data27[i0];
if(data28 && typeof data28 == "object" && !Array.isArray(data28)){
if(data28.id === undefined){
const err59 = {instancePath:instancePath+"/pages/" + i0,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
if(data28.pageIndex === undefined){
const err60 = {instancePath:instancePath+"/pages/" + i0,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/required",keyword:"required",params:{missingProperty: "pageIndex"},message:"must have required property '"+"pageIndex"+"'"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
if(data28.width === undefined){
const err61 = {instancePath:instancePath+"/pages/" + i0,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
if(data28.height === undefined){
const err62 = {instancePath:instancePath+"/pages/" + i0,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
if(data28.nodes === undefined){
const err63 = {instancePath:instancePath+"/pages/" + i0,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/required",keyword:"required",params:{missingProperty: "nodes"},message:"must have required property '"+"nodes"+"'"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
if(data28.id !== undefined){
if(typeof data28.id !== "string"){
const err64 = {instancePath:instancePath+"/pages/" + i0+"/id",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
}
if(data28.pageIndex !== undefined){
let data30 = data28.pageIndex;
if(!(((typeof data30 == "number") && (!(data30 % 1) && !isNaN(data30))) && (isFinite(data30)))){
const err65 = {instancePath:instancePath+"/pages/" + i0+"/pageIndex",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/pageIndex/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
if((typeof data30 == "number") && (isFinite(data30))){
if(data30 < 1 || isNaN(data30)){
const err66 = {instancePath:instancePath+"/pages/" + i0+"/pageIndex",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/pageIndex/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
}
if(data28.width !== undefined){
let data31 = data28.width;
if((typeof data31 == "number") && (isFinite(data31))){
if(data31 <= 0 || isNaN(data31)){
const err67 = {instancePath:instancePath+"/pages/" + i0+"/width",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/width/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
}
else {
const err68 = {instancePath:instancePath+"/pages/" + i0+"/width",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
}
if(data28.height !== undefined){
let data32 = data28.height;
if((typeof data32 == "number") && (isFinite(data32))){
if(data32 <= 0 || isNaN(data32)){
const err69 = {instancePath:instancePath+"/pages/" + i0+"/height",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/height/exclusiveMinimum",keyword:"exclusiveMinimum",params:{comparison: ">", limit: 0},message:"must be > 0"};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
else {
const err70 = {instancePath:instancePath+"/pages/" + i0+"/height",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
if(data28.nodes !== undefined){
let data33 = data28.nodes;
if(Array.isArray(data33)){
const len1 = data33.length;
for(let i1=0; i1<len1; i1++){
let data34 = data33[i1];
if(data34 && typeof data34 == "object" && !Array.isArray(data34)){
if(data34.id === undefined){
const err71 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
if(data34.kind === undefined){
const err72 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
if(data34.frame === undefined){
const err73 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/required",keyword:"required",params:{missingProperty: "frame"},message:"must have required property '"+"frame"+"'"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
if(data34.id !== undefined){
if(typeof data34.id !== "string"){
const err74 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/id",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
if(data34.kind !== undefined){
let data36 = data34.kind;
if(!(((((((data36 === "paragraph") || (data36 === "table")) || (data36 === "picture")) || (data36 === "page_number")) || (data36 === "shape")) || (data36 === "chart")) || (data36 === "unknown"))){
const err75 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/kind",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/kind/enum",keyword:"enum",params:{allowedValues: schema32.properties.pages.items.properties.nodes.items.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
}
if(data34.text !== undefined){
if(typeof data34.text !== "string"){
const err76 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/text",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/text/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
}
if(data34.frame !== undefined){
let data38 = data34.frame;
if(data38 && typeof data38 == "object" && !Array.isArray(data38)){
if(data38.unit === undefined){
const err77 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/required",keyword:"required",params:{missingProperty: "unit"},message:"must have required property '"+"unit"+"'"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
if(data38.x === undefined){
const err78 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/required",keyword:"required",params:{missingProperty: "x"},message:"must have required property '"+"x"+"'"};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
if(data38.y === undefined){
const err79 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/required",keyword:"required",params:{missingProperty: "y"},message:"must have required property '"+"y"+"'"};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
if(data38.width === undefined){
const err80 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
if(data38.height === undefined){
const err81 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
if(data38.unit !== undefined){
if("px" !== data38.unit){
const err82 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame/unit",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/properties/unit/const",keyword:"const",params:{allowedValue: "px"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err82];
}
else {
vErrors.push(err82);
}
errors++;
}
}
if(data38.x !== undefined){
let data40 = data38.x;
if(!((typeof data40 == "number") && (isFinite(data40)))){
const err83 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame/x",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/properties/x/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err83];
}
else {
vErrors.push(err83);
}
errors++;
}
}
if(data38.y !== undefined){
let data41 = data38.y;
if(!((typeof data41 == "number") && (isFinite(data41)))){
const err84 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame/y",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/properties/y/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err84];
}
else {
vErrors.push(err84);
}
errors++;
}
}
if(data38.width !== undefined){
let data42 = data38.width;
if((typeof data42 == "number") && (isFinite(data42))){
if(data42 < 0 || isNaN(data42)){
const err85 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame/width",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err85];
}
else {
vErrors.push(err85);
}
errors++;
}
}
else {
const err86 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame/width",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/properties/width/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err86];
}
else {
vErrors.push(err86);
}
errors++;
}
}
if(data38.height !== undefined){
let data43 = data38.height;
if((typeof data43 == "number") && (isFinite(data43))){
if(data43 < 0 || isNaN(data43)){
const err87 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame/height",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err87];
}
else {
vErrors.push(err87);
}
errors++;
}
}
else {
const err88 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame/height",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/properties/height/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err88];
}
else {
vErrors.push(err88);
}
errors++;
}
}
}
else {
const err89 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/frame",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/frame/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err89];
}
else {
vErrors.push(err89);
}
errors++;
}
}
if(data34.sourceTrace !== undefined){
let data44 = data34.sourceTrace;
if(data44 && typeof data44 == "object" && !Array.isArray(data44)){
}
else {
const err90 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1+"/sourceTrace",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/properties/sourceTrace/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err90];
}
else {
vErrors.push(err90);
}
errors++;
}
}
}
else {
const err91 = {instancePath:instancePath+"/pages/" + i0+"/nodes/" + i1,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err91];
}
else {
vErrors.push(err91);
}
errors++;
}
}
}
else {
const err92 = {instancePath:instancePath+"/pages/" + i0+"/nodes",schemaPath:"urn:cogo:v4:document-model/properties/pages/items/properties/nodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err92];
}
else {
vErrors.push(err92);
}
errors++;
}
}
}
else {
const err93 = {instancePath:instancePath+"/pages/" + i0,schemaPath:"urn:cogo:v4:document-model/properties/pages/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err93];
}
else {
vErrors.push(err93);
}
errors++;
}
}
}
else {
const err94 = {instancePath:instancePath+"/pages",schemaPath:"urn:cogo:v4:document-model/properties/pages/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err94];
}
else {
vErrors.push(err94);
}
errors++;
}
}
if(data.resources !== undefined){
let data45 = data.resources;
if(Array.isArray(data45)){
const len2 = data45.length;
for(let i2=0; i2<len2; i2++){
let data46 = data45[i2];
if(data46 && typeof data46 == "object" && !Array.isArray(data46)){
if(data46.id === undefined){
const err95 = {instancePath:instancePath+"/resources/" + i2,schemaPath:"urn:cogo:v4:document-model/properties/resources/items/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err95];
}
else {
vErrors.push(err95);
}
errors++;
}
if(data46.href === undefined){
const err96 = {instancePath:instancePath+"/resources/" + i2,schemaPath:"urn:cogo:v4:document-model/properties/resources/items/required",keyword:"required",params:{missingProperty: "href"},message:"must have required property '"+"href"+"'"};
if(vErrors === null){
vErrors = [err96];
}
else {
vErrors.push(err96);
}
errors++;
}
if(data46.id !== undefined){
if(typeof data46.id !== "string"){
const err97 = {instancePath:instancePath+"/resources/" + i2+"/id",schemaPath:"urn:cogo:v4:document-model/properties/resources/items/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err97];
}
else {
vErrors.push(err97);
}
errors++;
}
}
if(data46.href !== undefined){
if(typeof data46.href !== "string"){
const err98 = {instancePath:instancePath+"/resources/" + i2+"/href",schemaPath:"urn:cogo:v4:document-model/properties/resources/items/properties/href/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err98];
}
else {
vErrors.push(err98);
}
errors++;
}
}
if(data46.mediaType !== undefined){
if(typeof data46.mediaType !== "string"){
const err99 = {instancePath:instancePath+"/resources/" + i2+"/mediaType",schemaPath:"urn:cogo:v4:document-model/properties/resources/items/properties/mediaType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err99];
}
else {
vErrors.push(err99);
}
errors++;
}
}
if(data46.sha256 !== undefined){
let data50 = data46.sha256;
if(typeof data50 === "string"){
if(!pattern5.test(data50)){
const err100 = {instancePath:instancePath+"/resources/" + i2+"/sha256",schemaPath:"urn:cogo:v4:document-model/properties/resources/items/properties/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err100];
}
else {
vErrors.push(err100);
}
errors++;
}
}
else {
const err101 = {instancePath:instancePath+"/resources/" + i2+"/sha256",schemaPath:"urn:cogo:v4:document-model/properties/resources/items/properties/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err101];
}
else {
vErrors.push(err101);
}
errors++;
}
}
}
else {
const err102 = {instancePath:instancePath+"/resources/" + i2,schemaPath:"urn:cogo:v4:document-model/properties/resources/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err102];
}
else {
vErrors.push(err102);
}
errors++;
}
}
}
else {
const err103 = {instancePath:instancePath+"/resources",schemaPath:"urn:cogo:v4:document-model/properties/resources/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err103];
}
else {
vErrors.push(err103);
}
errors++;
}
}
if(data.styleCatalog !== undefined){
let data51 = data.styleCatalog;
if(data51 && typeof data51 == "object" && !Array.isArray(data51)){
if(data51.fontFace !== undefined){
let data52 = data51.fontFace;
if(data52 && typeof data52 == "object" && !Array.isArray(data52)){
}
else {
const err104 = {instancePath:instancePath+"/styleCatalog/fontFace",schemaPath:"urn:cogo:v4:document-model/properties/styleCatalog/properties/fontFace/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err104];
}
else {
vErrors.push(err104);
}
errors++;
}
}
if(data51.charPr !== undefined){
let data53 = data51.charPr;
if(data53 && typeof data53 == "object" && !Array.isArray(data53)){
}
else {
const err105 = {instancePath:instancePath+"/styleCatalog/charPr",schemaPath:"urn:cogo:v4:document-model/properties/styleCatalog/properties/charPr/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err105];
}
else {
vErrors.push(err105);
}
errors++;
}
}
if(data51.paraPr !== undefined){
let data54 = data51.paraPr;
if(data54 && typeof data54 == "object" && !Array.isArray(data54)){
}
else {
const err106 = {instancePath:instancePath+"/styleCatalog/paraPr",schemaPath:"urn:cogo:v4:document-model/properties/styleCatalog/properties/paraPr/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err106];
}
else {
vErrors.push(err106);
}
errors++;
}
}
if(data51.borderFill !== undefined){
let data55 = data51.borderFill;
if(data55 && typeof data55 == "object" && !Array.isArray(data55)){
}
else {
const err107 = {instancePath:instancePath+"/styleCatalog/borderFill",schemaPath:"urn:cogo:v4:document-model/properties/styleCatalog/properties/borderFill/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err107];
}
else {
vErrors.push(err107);
}
errors++;
}
}
}
else {
const err108 = {instancePath:instancePath+"/styleCatalog",schemaPath:"urn:cogo:v4:document-model/properties/styleCatalog/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err108];
}
else {
vErrors.push(err108);
}
errors++;
}
}
if(data.visualLayer !== undefined){
let data56 = data.visualLayer;
if(data56 && typeof data56 == "object" && !Array.isArray(data56)){
if(data56.mode !== undefined){
if(typeof data56.mode !== "string"){
const err109 = {instancePath:instancePath+"/visualLayer/mode",schemaPath:"urn:cogo:v4:document-model/properties/visualLayer/properties/mode/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err109];
}
else {
vErrors.push(err109);
}
errors++;
}
}
if(data56.locked !== undefined){
if(typeof data56.locked !== "boolean"){
const err110 = {instancePath:instancePath+"/visualLayer/locked",schemaPath:"urn:cogo:v4:document-model/properties/visualLayer/properties/locked/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err110];
}
else {
vErrors.push(err110);
}
errors++;
}
}
if(data56.editable !== undefined){
if(typeof data56.editable !== "boolean"){
const err111 = {instancePath:instancePath+"/visualLayer/editable",schemaPath:"urn:cogo:v4:document-model/properties/visualLayer/properties/editable/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err111];
}
else {
vErrors.push(err111);
}
errors++;
}
}
if(data56.resourceCount !== undefined){
let data60 = data56.resourceCount;
if(!(((typeof data60 == "number") && (!(data60 % 1) && !isNaN(data60))) && (isFinite(data60)))){
const err112 = {instancePath:instancePath+"/visualLayer/resourceCount",schemaPath:"urn:cogo:v4:document-model/properties/visualLayer/properties/resourceCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err112];
}
else {
vErrors.push(err112);
}
errors++;
}
if((typeof data60 == "number") && (isFinite(data60))){
if(data60 < 0 || isNaN(data60)){
const err113 = {instancePath:instancePath+"/visualLayer/resourceCount",schemaPath:"urn:cogo:v4:document-model/properties/visualLayer/properties/resourceCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err113];
}
else {
vErrors.push(err113);
}
errors++;
}
}
}
if(data56.exactVisualAuthority !== undefined){
if(typeof data56.exactVisualAuthority !== "string"){
const err114 = {instancePath:instancePath+"/visualLayer/exactVisualAuthority",schemaPath:"urn:cogo:v4:document-model/properties/visualLayer/properties/exactVisualAuthority/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err114];
}
else {
vErrors.push(err114);
}
errors++;
}
}
if(data56.sourceRenderer !== undefined){
if(typeof data56.sourceRenderer !== "string"){
const err115 = {instancePath:instancePath+"/visualLayer/sourceRenderer",schemaPath:"urn:cogo:v4:document-model/properties/visualLayer/properties/sourceRenderer/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err115];
}
else {
vErrors.push(err115);
}
errors++;
}
}
}
else {
const err116 = {instancePath:instancePath+"/visualLayer",schemaPath:"urn:cogo:v4:document-model/properties/visualLayer/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err116];
}
else {
vErrors.push(err116);
}
errors++;
}
}
if(data.semanticSignature !== undefined){
let data63 = data.semanticSignature;
if(data63 && typeof data63 == "object" && !Array.isArray(data63)){
if(data63.schemaVersion !== undefined){
if(typeof data63.schemaVersion !== "string"){
const err117 = {instancePath:instancePath+"/semanticSignature/schemaVersion",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/schemaVersion/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err117];
}
else {
vErrors.push(err117);
}
errors++;
}
}
if(data63.format !== undefined){
let data65 = data63.format;
if(!((((data65 === "pdf") || (data65 === "docx")) || (data65 === "pptx")) || (data65 === "hwpx"))){
const err118 = {instancePath:instancePath+"/semanticSignature/format",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/format/enum",keyword:"enum",params:{allowedValues: schema32.properties.semanticSignature.properties.format.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err118];
}
else {
vErrors.push(err118);
}
errors++;
}
}
if(data63.sourceKind !== undefined){
let data66 = data63.sourceKind;
if(!((((data66 === "real-source") || (data66 === "real-source-derived")) || (data66 === "generated-control")) || (data66 === "generated"))){
const err119 = {instancePath:instancePath+"/semanticSignature/sourceKind",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/sourceKind/enum",keyword:"enum",params:{allowedValues: schema32.properties.semanticSignature.properties.sourceKind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err119];
}
else {
vErrors.push(err119);
}
errors++;
}
}
if(data63.importTier !== undefined){
if(typeof data63.importTier !== "string"){
const err120 = {instancePath:instancePath+"/semanticSignature/importTier",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/importTier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err120];
}
else {
vErrors.push(err120);
}
errors++;
}
}
if(data63.normalizedTextHash !== undefined){
let data68 = data63.normalizedTextHash;
if(typeof data68 === "string"){
if(!pattern5.test(data68)){
const err121 = {instancePath:instancePath+"/semanticSignature/normalizedTextHash",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/normalizedTextHash/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err121];
}
else {
vErrors.push(err121);
}
errors++;
}
}
else {
const err122 = {instancePath:instancePath+"/semanticSignature/normalizedTextHash",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/normalizedTextHash/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err122];
}
else {
vErrors.push(err122);
}
errors++;
}
}
if(data63.normalizedTextLength !== undefined){
let data69 = data63.normalizedTextLength;
if(!(((typeof data69 == "number") && (!(data69 % 1) && !isNaN(data69))) && (isFinite(data69)))){
const err123 = {instancePath:instancePath+"/semanticSignature/normalizedTextLength",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/normalizedTextLength/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err123];
}
else {
vErrors.push(err123);
}
errors++;
}
if((typeof data69 == "number") && (isFinite(data69))){
if(data69 < 0 || isNaN(data69)){
const err124 = {instancePath:instancePath+"/semanticSignature/normalizedTextLength",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/normalizedTextLength/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err124];
}
else {
vErrors.push(err124);
}
errors++;
}
}
}
if(data63.pageCount !== undefined){
let data70 = data63.pageCount;
if(!(((typeof data70 == "number") && (!(data70 % 1) && !isNaN(data70))) && (isFinite(data70)))){
const err125 = {instancePath:instancePath+"/semanticSignature/pageCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/pageCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err125];
}
else {
vErrors.push(err125);
}
errors++;
}
if((typeof data70 == "number") && (isFinite(data70))){
if(data70 < 0 || isNaN(data70)){
const err126 = {instancePath:instancePath+"/semanticSignature/pageCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/pageCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err126];
}
else {
vErrors.push(err126);
}
errors++;
}
}
}
if(data63.objectCount !== undefined){
let data71 = data63.objectCount;
if(!(((typeof data71 == "number") && (!(data71 % 1) && !isNaN(data71))) && (isFinite(data71)))){
const err127 = {instancePath:instancePath+"/semanticSignature/objectCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/objectCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err127];
}
else {
vErrors.push(err127);
}
errors++;
}
if((typeof data71 == "number") && (isFinite(data71))){
if(data71 < 0 || isNaN(data71)){
const err128 = {instancePath:instancePath+"/semanticSignature/objectCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/objectCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err128];
}
else {
vErrors.push(err128);
}
errors++;
}
}
}
if(data63.packageEntryCount !== undefined){
let data72 = data63.packageEntryCount;
if(!(((typeof data72 == "number") && (!(data72 % 1) && !isNaN(data72))) && (isFinite(data72)))){
const err129 = {instancePath:instancePath+"/semanticSignature/packageEntryCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/packageEntryCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err129];
}
else {
vErrors.push(err129);
}
errors++;
}
if((typeof data72 == "number") && (isFinite(data72))){
if(data72 < 0 || isNaN(data72)){
const err130 = {instancePath:instancePath+"/semanticSignature/packageEntryCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/properties/packageEntryCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err130];
}
else {
vErrors.push(err130);
}
errors++;
}
}
}
}
else {
const err131 = {instancePath:instancePath+"/semanticSignature",schemaPath:"urn:cogo:v4:document-model/properties/semanticSignature/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err131];
}
else {
vErrors.push(err131);
}
errors++;
}
}
if(data.layoutGraphSnapshot !== undefined){
let data73 = data.layoutGraphSnapshot;
if(data73 && typeof data73 == "object" && !Array.isArray(data73)){
if(data73.schemaVersion !== undefined){
if("cogo.hwpx-layout-graph.v1" !== data73.schemaVersion){
const err132 = {instancePath:instancePath+"/layoutGraphSnapshot/schemaVersion",schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.hwpx-layout-graph.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err132];
}
else {
vErrors.push(err132);
}
errors++;
}
}
if(data73.source !== undefined){
let data75 = data73.source;
if(data75 && typeof data75 == "object" && !Array.isArray(data75)){
}
else {
const err133 = {instancePath:instancePath+"/layoutGraphSnapshot/source",schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/source/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err133];
}
else {
vErrors.push(err133);
}
errors++;
}
}
if(data73.pageSetup !== undefined){
let data76 = data73.pageSetup;
if(data76 && typeof data76 == "object" && !Array.isArray(data76)){
}
else {
const err134 = {instancePath:instancePath+"/layoutGraphSnapshot/pageSetup",schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/pageSetup/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err134];
}
else {
vErrors.push(err134);
}
errors++;
}
}
if(data73.pages !== undefined){
let data77 = data73.pages;
if(Array.isArray(data77)){
const len3 = data77.length;
for(let i3=0; i3<len3; i3++){
let data78 = data77[i3];
if(data78 && typeof data78 == "object" && !Array.isArray(data78)){
}
else {
const err135 = {instancePath:instancePath+"/layoutGraphSnapshot/pages/" + i3,schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/pages/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err135];
}
else {
vErrors.push(err135);
}
errors++;
}
}
}
else {
const err136 = {instancePath:instancePath+"/layoutGraphSnapshot/pages",schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/pages/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err136];
}
else {
vErrors.push(err136);
}
errors++;
}
}
if(data73.nodes !== undefined){
let data79 = data73.nodes;
if(Array.isArray(data79)){
const len4 = data79.length;
for(let i4=0; i4<len4; i4++){
let data80 = data79[i4];
if(data80 && typeof data80 == "object" && !Array.isArray(data80)){
}
else {
const err137 = {instancePath:instancePath+"/layoutGraphSnapshot/nodes/" + i4,schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/nodes/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err137];
}
else {
vErrors.push(err137);
}
errors++;
}
}
}
else {
const err138 = {instancePath:instancePath+"/layoutGraphSnapshot/nodes",schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/nodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err138];
}
else {
vErrors.push(err138);
}
errors++;
}
}
if(data73.resources !== undefined){
let data81 = data73.resources;
if(Array.isArray(data81)){
const len5 = data81.length;
for(let i5=0; i5<len5; i5++){
let data82 = data81[i5];
if(data82 && typeof data82 == "object" && !Array.isArray(data82)){
}
else {
const err139 = {instancePath:instancePath+"/layoutGraphSnapshot/resources/" + i5,schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/resources/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err139];
}
else {
vErrors.push(err139);
}
errors++;
}
}
}
else {
const err140 = {instancePath:instancePath+"/layoutGraphSnapshot/resources",schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/properties/resources/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err140];
}
else {
vErrors.push(err140);
}
errors++;
}
}
}
else {
const err141 = {instancePath:instancePath+"/layoutGraphSnapshot",schemaPath:"urn:cogo:v4:document-model/properties/layoutGraphSnapshot/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err141];
}
else {
vErrors.push(err141);
}
errors++;
}
}
if(data.layoutProfile !== undefined){
let data83 = data.layoutProfile;
if(data83 && typeof data83 == "object" && !Array.isArray(data83)){
if(data83.coordinateSystem !== undefined){
if(typeof data83.coordinateSystem !== "string"){
const err142 = {instancePath:instancePath+"/layoutProfile/coordinateSystem",schemaPath:"urn:cogo:v4:document-model/properties/layoutProfile/properties/coordinateSystem/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err142];
}
else {
vErrors.push(err142);
}
errors++;
}
}
if(data83.visualPreservationLayer !== undefined){
if(typeof data83.visualPreservationLayer !== "string"){
const err143 = {instancePath:instancePath+"/layoutProfile/visualPreservationLayer",schemaPath:"urn:cogo:v4:document-model/properties/layoutProfile/properties/visualPreservationLayer/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err143];
}
else {
vErrors.push(err143);
}
errors++;
}
}
if(data83.editableSemanticLayer !== undefined){
if(typeof data83.editableSemanticLayer !== "string"){
const err144 = {instancePath:instancePath+"/layoutProfile/editableSemanticLayer",schemaPath:"urn:cogo:v4:document-model/properties/layoutProfile/properties/editableSemanticLayer/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err144];
}
else {
vErrors.push(err144);
}
errors++;
}
}
}
else {
const err145 = {instancePath:instancePath+"/layoutProfile",schemaPath:"urn:cogo:v4:document-model/properties/layoutProfile/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err145];
}
else {
vErrors.push(err145);
}
errors++;
}
}
if(data.fontPolicy !== undefined){
let data87 = data.fontPolicy;
if(data87 && typeof data87 == "object" && !Array.isArray(data87)){
}
else {
const err146 = {instancePath:instancePath+"/fontPolicy",schemaPath:"urn:cogo:v4:document-model/properties/fontPolicy/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err146];
}
else {
vErrors.push(err146);
}
errors++;
}
}
if(data.designSystemRefs !== undefined){
let data88 = data.designSystemRefs;
if(Array.isArray(data88)){
const len6 = data88.length;
for(let i6=0; i6<len6; i6++){
if(typeof data88[i6] !== "string"){
const err147 = {instancePath:instancePath+"/designSystemRefs/" + i6,schemaPath:"urn:cogo:v4:document-model/properties/designSystemRefs/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err147];
}
else {
vErrors.push(err147);
}
errors++;
}
}
}
else {
const err148 = {instancePath:instancePath+"/designSystemRefs",schemaPath:"urn:cogo:v4:document-model/properties/designSystemRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err148];
}
else {
vErrors.push(err148);
}
errors++;
}
}
if(data.semanticNativeLayer !== undefined){
let data90 = data.semanticNativeLayer;
if(data90 && typeof data90 == "object" && !Array.isArray(data90)){
if(data90.schemaVersion === undefined){
const err149 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err149];
}
else {
vErrors.push(err149);
}
errors++;
}
if(data90.authority === undefined){
const err150 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/required",keyword:"required",params:{missingProperty: "authority"},message:"must have required property '"+"authority"+"'"};
if(vErrors === null){
vErrors = [err150];
}
else {
vErrors.push(err150);
}
errors++;
}
if(data90.pageCount === undefined){
const err151 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/required",keyword:"required",params:{missingProperty: "pageCount"},message:"must have required property '"+"pageCount"+"'"};
if(vErrors === null){
vErrors = [err151];
}
else {
vErrors.push(err151);
}
errors++;
}
if(data90.nodeCount === undefined){
const err152 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/required",keyword:"required",params:{missingProperty: "nodeCount"},message:"must have required property '"+"nodeCount"+"'"};
if(vErrors === null){
vErrors = [err152];
}
else {
vErrors.push(err152);
}
errors++;
}
if(data90.kindCounts === undefined){
const err153 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/required",keyword:"required",params:{missingProperty: "kindCounts"},message:"must have required property '"+"kindCounts"+"'"};
if(vErrors === null){
vErrors = [err153];
}
else {
vErrors.push(err153);
}
errors++;
}
if(data90.tableCount === undefined){
const err154 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/required",keyword:"required",params:{missingProperty: "tableCount"},message:"must have required property '"+"tableCount"+"'"};
if(vErrors === null){
vErrors = [err154];
}
else {
vErrors.push(err154);
}
errors++;
}
if(data90.cellCount === undefined){
const err155 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/required",keyword:"required",params:{missingProperty: "cellCount"},message:"must have required property '"+"cellCount"+"'"};
if(vErrors === null){
vErrors = [err155];
}
else {
vErrors.push(err155);
}
errors++;
}
if(data90.nativeExportRequirements === undefined){
const err156 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/required",keyword:"required",params:{missingProperty: "nativeExportRequirements"},message:"must have required property '"+"nativeExportRequirements"+"'"};
if(vErrors === null){
vErrors = [err156];
}
else {
vErrors.push(err156);
}
errors++;
}
if(data90.schemaVersion !== undefined){
if("cogo.document-semantic-native-layer.v1" !== data90.schemaVersion){
const err157 = {instancePath:instancePath+"/semanticNativeLayer/schemaVersion",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.document-semantic-native-layer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err157];
}
else {
vErrors.push(err157);
}
errors++;
}
}
if(data90.authority !== undefined){
let data92 = data90.authority;
if(typeof data92 === "string"){
if(func2(data92) < 1){
const err158 = {instancePath:instancePath+"/semanticNativeLayer/authority",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/authority/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err158];
}
else {
vErrors.push(err158);
}
errors++;
}
}
else {
const err159 = {instancePath:instancePath+"/semanticNativeLayer/authority",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/authority/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err159];
}
else {
vErrors.push(err159);
}
errors++;
}
}
if(data90.pageCount !== undefined){
let data93 = data90.pageCount;
if(!(((typeof data93 == "number") && (!(data93 % 1) && !isNaN(data93))) && (isFinite(data93)))){
const err160 = {instancePath:instancePath+"/semanticNativeLayer/pageCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/pageCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err160];
}
else {
vErrors.push(err160);
}
errors++;
}
if((typeof data93 == "number") && (isFinite(data93))){
if(data93 < 1 || isNaN(data93)){
const err161 = {instancePath:instancePath+"/semanticNativeLayer/pageCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/pageCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err161];
}
else {
vErrors.push(err161);
}
errors++;
}
}
}
if(data90.nodeCount !== undefined){
let data94 = data90.nodeCount;
if(!(((typeof data94 == "number") && (!(data94 % 1) && !isNaN(data94))) && (isFinite(data94)))){
const err162 = {instancePath:instancePath+"/semanticNativeLayer/nodeCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nodeCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err162];
}
else {
vErrors.push(err162);
}
errors++;
}
if((typeof data94 == "number") && (isFinite(data94))){
if(data94 < 0 || isNaN(data94)){
const err163 = {instancePath:instancePath+"/semanticNativeLayer/nodeCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nodeCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err163];
}
else {
vErrors.push(err163);
}
errors++;
}
}
}
if(data90.kindCounts !== undefined){
let data95 = data90.kindCounts;
if(data95 && typeof data95 == "object" && !Array.isArray(data95)){
for(const key2 in data95){
let data96 = data95[key2];
if(!(((typeof data96 == "number") && (!(data96 % 1) && !isNaN(data96))) && (isFinite(data96)))){
const err164 = {instancePath:instancePath+"/semanticNativeLayer/kindCounts/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"),schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/kindCounts/additionalProperties/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err164];
}
else {
vErrors.push(err164);
}
errors++;
}
if((typeof data96 == "number") && (isFinite(data96))){
if(data96 < 0 || isNaN(data96)){
const err165 = {instancePath:instancePath+"/semanticNativeLayer/kindCounts/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"),schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/kindCounts/additionalProperties/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err165];
}
else {
vErrors.push(err165);
}
errors++;
}
}
}
}
else {
const err166 = {instancePath:instancePath+"/semanticNativeLayer/kindCounts",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/kindCounts/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err166];
}
else {
vErrors.push(err166);
}
errors++;
}
}
if(data90.tableCount !== undefined){
let data97 = data90.tableCount;
if(!(((typeof data97 == "number") && (!(data97 % 1) && !isNaN(data97))) && (isFinite(data97)))){
const err167 = {instancePath:instancePath+"/semanticNativeLayer/tableCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/tableCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err167];
}
else {
vErrors.push(err167);
}
errors++;
}
if((typeof data97 == "number") && (isFinite(data97))){
if(data97 < 0 || isNaN(data97)){
const err168 = {instancePath:instancePath+"/semanticNativeLayer/tableCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/tableCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err168];
}
else {
vErrors.push(err168);
}
errors++;
}
}
}
if(data90.rowCount !== undefined){
let data98 = data90.rowCount;
if(!(((typeof data98 == "number") && (!(data98 % 1) && !isNaN(data98))) && (isFinite(data98)))){
const err169 = {instancePath:instancePath+"/semanticNativeLayer/rowCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/rowCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err169];
}
else {
vErrors.push(err169);
}
errors++;
}
if((typeof data98 == "number") && (isFinite(data98))){
if(data98 < 0 || isNaN(data98)){
const err170 = {instancePath:instancePath+"/semanticNativeLayer/rowCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/rowCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err170];
}
else {
vErrors.push(err170);
}
errors++;
}
}
}
if(data90.columnCountMax !== undefined){
let data99 = data90.columnCountMax;
if(!(((typeof data99 == "number") && (!(data99 % 1) && !isNaN(data99))) && (isFinite(data99)))){
const err171 = {instancePath:instancePath+"/semanticNativeLayer/columnCountMax",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/columnCountMax/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err171];
}
else {
vErrors.push(err171);
}
errors++;
}
if((typeof data99 == "number") && (isFinite(data99))){
if(data99 < 0 || isNaN(data99)){
const err172 = {instancePath:instancePath+"/semanticNativeLayer/columnCountMax",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/columnCountMax/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err172];
}
else {
vErrors.push(err172);
}
errors++;
}
}
}
if(data90.cellCount !== undefined){
let data100 = data90.cellCount;
if(!(((typeof data100 == "number") && (!(data100 % 1) && !isNaN(data100))) && (isFinite(data100)))){
const err173 = {instancePath:instancePath+"/semanticNativeLayer/cellCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/cellCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err173];
}
else {
vErrors.push(err173);
}
errors++;
}
if((typeof data100 == "number") && (isFinite(data100))){
if(data100 < 0 || isNaN(data100)){
const err174 = {instancePath:instancePath+"/semanticNativeLayer/cellCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/cellCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err174];
}
else {
vErrors.push(err174);
}
errors++;
}
}
}
if(data90.preserves !== undefined){
let data101 = data90.preserves;
if(Array.isArray(data101)){
const len7 = data101.length;
for(let i7=0; i7<len7; i7++){
if(typeof data101[i7] !== "string"){
const err175 = {instancePath:instancePath+"/semanticNativeLayer/preserves/" + i7,schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/preserves/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err175];
}
else {
vErrors.push(err175);
}
errors++;
}
}
}
else {
const err176 = {instancePath:instancePath+"/semanticNativeLayer/preserves",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/preserves/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err176];
}
else {
vErrors.push(err176);
}
errors++;
}
}
if(data90.nativeExportRequirements !== undefined){
let data103 = data90.nativeExportRequirements;
if(data103 && typeof data103 == "object" && !Array.isArray(data103)){
if(data103.pdf === undefined){
const err177 = {instancePath:instancePath+"/semanticNativeLayer/nativeExportRequirements",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nativeExportRequirements/required",keyword:"required",params:{missingProperty: "pdf"},message:"must have required property '"+"pdf"+"'"};
if(vErrors === null){
vErrors = [err177];
}
else {
vErrors.push(err177);
}
errors++;
}
if(data103.docx === undefined){
const err178 = {instancePath:instancePath+"/semanticNativeLayer/nativeExportRequirements",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nativeExportRequirements/required",keyword:"required",params:{missingProperty: "docx"},message:"must have required property '"+"docx"+"'"};
if(vErrors === null){
vErrors = [err178];
}
else {
vErrors.push(err178);
}
errors++;
}
if(data103.pptx === undefined){
const err179 = {instancePath:instancePath+"/semanticNativeLayer/nativeExportRequirements",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nativeExportRequirements/required",keyword:"required",params:{missingProperty: "pptx"},message:"must have required property '"+"pptx"+"'"};
if(vErrors === null){
vErrors = [err179];
}
else {
vErrors.push(err179);
}
errors++;
}
if(data103.hwpx === undefined){
const err180 = {instancePath:instancePath+"/semanticNativeLayer/nativeExportRequirements",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nativeExportRequirements/required",keyword:"required",params:{missingProperty: "hwpx"},message:"must have required property '"+"hwpx"+"'"};
if(vErrors === null){
vErrors = [err180];
}
else {
vErrors.push(err180);
}
errors++;
}
for(const key3 in data103){
let data104 = data103[key3];
if(Array.isArray(data104)){
const len8 = data104.length;
for(let i8=0; i8<len8; i8++){
if(typeof data104[i8] !== "string"){
const err181 = {instancePath:instancePath+"/semanticNativeLayer/nativeExportRequirements/" + key3.replace(/~/g, "~0").replace(/\//g, "~1")+"/" + i8,schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nativeExportRequirements/additionalProperties/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err181];
}
else {
vErrors.push(err181);
}
errors++;
}
}
}
else {
const err182 = {instancePath:instancePath+"/semanticNativeLayer/nativeExportRequirements/" + key3.replace(/~/g, "~0").replace(/\//g, "~1"),schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nativeExportRequirements/additionalProperties/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err182];
}
else {
vErrors.push(err182);
}
errors++;
}
}
}
else {
const err183 = {instancePath:instancePath+"/semanticNativeLayer/nativeExportRequirements",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/properties/nativeExportRequirements/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err183];
}
else {
vErrors.push(err183);
}
errors++;
}
}
}
else {
const err184 = {instancePath:instancePath+"/semanticNativeLayer",schemaPath:"urn:cogo:v4:document-model/properties/semanticNativeLayer/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err184];
}
else {
vErrors.push(err184);
}
errors++;
}
}
if(data.semanticEditPlan !== undefined){
let data106 = data.semanticEditPlan;
if(data106 && typeof data106 == "object" && !Array.isArray(data106)){
if(data106.schemaVersion !== undefined){
if("cogo.document-semantic-edit-plan.v1" !== data106.schemaVersion){
const err185 = {instancePath:instancePath+"/semanticEditPlan/schemaVersion",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.document-semantic-edit-plan.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err185];
}
else {
vErrors.push(err185);
}
errors++;
}
}
if(data106.operation !== undefined){
if(typeof data106.operation !== "string"){
const err186 = {instancePath:instancePath+"/semanticEditPlan/operation",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/properties/operation/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err186];
}
else {
vErrors.push(err186);
}
errors++;
}
}
if(data106.authority !== undefined){
if(typeof data106.authority !== "string"){
const err187 = {instancePath:instancePath+"/semanticEditPlan/authority",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/properties/authority/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err187];
}
else {
vErrors.push(err187);
}
errors++;
}
}
if(data106.targetNodeId !== undefined){
if(typeof data106.targetNodeId !== "string"){
const err188 = {instancePath:instancePath+"/semanticEditPlan/targetNodeId",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/properties/targetNodeId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err188];
}
else {
vErrors.push(err188);
}
errors++;
}
}
if(data106.before !== undefined){
if(typeof data106.before !== "string"){
const err189 = {instancePath:instancePath+"/semanticEditPlan/before",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/properties/before/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err189];
}
else {
vErrors.push(err189);
}
errors++;
}
}
if(data106.after !== undefined){
if(typeof data106.after !== "string"){
const err190 = {instancePath:instancePath+"/semanticEditPlan/after",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/properties/after/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err190];
}
else {
vErrors.push(err190);
}
errors++;
}
}
if(data106.replacementCount !== undefined){
let data113 = data106.replacementCount;
if(!(((typeof data113 == "number") && (!(data113 % 1) && !isNaN(data113))) && (isFinite(data113)))){
const err191 = {instancePath:instancePath+"/semanticEditPlan/replacementCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/properties/replacementCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err191];
}
else {
vErrors.push(err191);
}
errors++;
}
if((typeof data113 == "number") && (isFinite(data113))){
if(data113 < 1 || isNaN(data113)){
const err192 = {instancePath:instancePath+"/semanticEditPlan/replacementCount",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/properties/replacementCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err192];
}
else {
vErrors.push(err192);
}
errors++;
}
}
}
}
else {
const err193 = {instancePath:instancePath+"/semanticEditPlan",schemaPath:"urn:cogo:v4:document-model/properties/semanticEditPlan/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err193];
}
else {
vErrors.push(err193);
}
errors++;
}
}
if(data.editableExportPolicy !== undefined){
let data114 = data.editableExportPolicy;
if(data114 && typeof data114 == "object" && !Array.isArray(data114)){
if(data114.mode !== undefined){
if(typeof data114.mode !== "string"){
const err194 = {instancePath:instancePath+"/editableExportPolicy/mode",schemaPath:"urn:cogo:v4:document-model/properties/editableExportPolicy/properties/mode/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err194];
}
else {
vErrors.push(err194);
}
errors++;
}
}
if(data114.cogoJsonIsAuthority !== undefined){
if(typeof data114.cogoJsonIsAuthority !== "boolean"){
const err195 = {instancePath:instancePath+"/editableExportPolicy/cogoJsonIsAuthority",schemaPath:"urn:cogo:v4:document-model/properties/editableExportPolicy/properties/cogoJsonIsAuthority/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err195];
}
else {
vErrors.push(err195);
}
errors++;
}
}
if(data114.semanticNativeStructureRequired !== undefined){
if(typeof data114.semanticNativeStructureRequired !== "boolean"){
const err196 = {instancePath:instancePath+"/editableExportPolicy/semanticNativeStructureRequired",schemaPath:"urn:cogo:v4:document-model/properties/editableExportPolicy/properties/semanticNativeStructureRequired/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err196];
}
else {
vErrors.push(err196);
}
errors++;
}
}
if(data114.visualPreservationAllowed !== undefined){
if(typeof data114.visualPreservationAllowed !== "boolean"){
const err197 = {instancePath:instancePath+"/editableExportPolicy/visualPreservationAllowed",schemaPath:"urn:cogo:v4:document-model/properties/editableExportPolicy/properties/visualPreservationAllowed/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err197];
}
else {
vErrors.push(err197);
}
errors++;
}
}
}
else {
const err198 = {instancePath:instancePath+"/editableExportPolicy",schemaPath:"urn:cogo:v4:document-model/properties/editableExportPolicy/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err198];
}
else {
vErrors.push(err198);
}
errors++;
}
}
if(data.renderingProfiles !== undefined){
let data119 = data.renderingProfiles;
if(Array.isArray(data119)){
if(data119.length < 3){
const err199 = {instancePath:instancePath+"/renderingProfiles",schemaPath:"urn:cogo:v4:document-model/properties/renderingProfiles/minItems",keyword:"minItems",params:{limit: 3},message:"must NOT have fewer than 3 items"};
if(vErrors === null){
vErrors = [err199];
}
else {
vErrors.push(err199);
}
errors++;
}
const len9 = data119.length;
for(let i9=0; i9<len9; i9++){
let data120 = data119[i9];
if(!(((data120 === "development-validation") || (data120 === "studio-preview")) || (data120 === "production-export"))){
const err200 = {instancePath:instancePath+"/renderingProfiles/" + i9,schemaPath:"urn:cogo:v4:document-model/properties/renderingProfiles/items/enum",keyword:"enum",params:{allowedValues: schema32.properties.renderingProfiles.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err200];
}
else {
vErrors.push(err200);
}
errors++;
}
}
const _errs261 = errors;
const len10 = data119.length;
for(let i10=0; i10<len10; i10++){
const _errs262 = errors;
if("production-export" !== data119[i10]){
const err201 = {instancePath:instancePath+"/renderingProfiles/" + i10,schemaPath:"urn:cogo:v4:document-model/properties/renderingProfiles/contains/const",keyword:"const",params:{allowedValue: "production-export"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err201];
}
else {
vErrors.push(err201);
}
errors++;
}
var valid41 = _errs262 === errors;
if(valid41){
break;
}
}
if(!valid41){
const err202 = {instancePath:instancePath+"/renderingProfiles",schemaPath:"urn:cogo:v4:document-model/properties/renderingProfiles/contains",keyword:"contains",params:{minContains: 1},message:"must contain at least 1 valid item(s)"};
if(vErrors === null){
vErrors = [err202];
}
else {
vErrors.push(err202);
}
errors++;
}
else {
errors = _errs261;
if(vErrors !== null){
if(_errs261){
vErrors.length = _errs261;
}
else {
vErrors = null;
}
}
}
}
else {
const err203 = {instancePath:instancePath+"/renderingProfiles",schemaPath:"urn:cogo:v4:document-model/properties/renderingProfiles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err203];
}
else {
vErrors.push(err203);
}
errors++;
}
}
if(data.exportPolicy !== undefined){
let data122 = data.exportPolicy;
if(data122 && typeof data122 == "object" && !Array.isArray(data122)){
if(data122.targets === undefined){
const err204 = {instancePath:instancePath+"/exportPolicy",schemaPath:"urn:cogo:v4:document-model/properties/exportPolicy/required",keyword:"required",params:{missingProperty: "targets"},message:"must have required property '"+"targets"+"'"};
if(vErrors === null){
vErrors = [err204];
}
else {
vErrors.push(err204);
}
errors++;
}
if(data122.hwpBinaryScope === undefined){
const err205 = {instancePath:instancePath+"/exportPolicy",schemaPath:"urn:cogo:v4:document-model/properties/exportPolicy/required",keyword:"required",params:{missingProperty: "hwpBinaryScope"},message:"must have required property '"+"hwpBinaryScope"+"'"};
if(vErrors === null){
vErrors = [err205];
}
else {
vErrors.push(err205);
}
errors++;
}
if(data122.targets !== undefined){
let data123 = data122.targets;
if(Array.isArray(data123)){
if(data123.length < 1){
const err206 = {instancePath:instancePath+"/exportPolicy/targets",schemaPath:"urn:cogo:v4:document-model/properties/exportPolicy/properties/targets/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err206];
}
else {
vErrors.push(err206);
}
errors++;
}
const len11 = data123.length;
for(let i11=0; i11<len11; i11++){
let data124 = data123[i11];
if(!(((((data124 === "pdf") || (data124 === "docx")) || (data124 === "pptx")) || (data124 === "hwpx")) || (data124 === "xlsx"))){
const err207 = {instancePath:instancePath+"/exportPolicy/targets/" + i11,schemaPath:"urn:cogo:v4:document-model/properties/exportPolicy/properties/targets/items/enum",keyword:"enum",params:{allowedValues: schema32.properties.exportPolicy.properties.targets.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err207];
}
else {
vErrors.push(err207);
}
errors++;
}
}
}
else {
const err208 = {instancePath:instancePath+"/exportPolicy/targets",schemaPath:"urn:cogo:v4:document-model/properties/exportPolicy/properties/targets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err208];
}
else {
vErrors.push(err208);
}
errors++;
}
}
if(data122.hwpBinaryScope !== undefined){
if("excluded" !== data122.hwpBinaryScope){
const err209 = {instancePath:instancePath+"/exportPolicy/hwpBinaryScope",schemaPath:"urn:cogo:v4:document-model/properties/exportPolicy/properties/hwpBinaryScope/const",keyword:"const",params:{allowedValue: "excluded"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err209];
}
else {
vErrors.push(err209);
}
errors++;
}
}
}
else {
const err210 = {instancePath:instancePath+"/exportPolicy",schemaPath:"urn:cogo:v4:document-model/properties/exportPolicy/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err210];
}
else {
vErrors.push(err210);
}
errors++;
}
}
if(data.integrity !== undefined){
let data126 = data.integrity;
if(data126 && typeof data126 == "object" && !Array.isArray(data126)){
if(data126.documentModelSha256 === undefined){
const err211 = {instancePath:instancePath+"/integrity",schemaPath:"urn:cogo:v4:document-model/properties/integrity/required",keyword:"required",params:{missingProperty: "documentModelSha256"},message:"must have required property '"+"documentModelSha256"+"'"};
if(vErrors === null){
vErrors = [err211];
}
else {
vErrors.push(err211);
}
errors++;
}
if(data126.pageCount === undefined){
const err212 = {instancePath:instancePath+"/integrity",schemaPath:"urn:cogo:v4:document-model/properties/integrity/required",keyword:"required",params:{missingProperty: "pageCount"},message:"must have required property '"+"pageCount"+"'"};
if(vErrors === null){
vErrors = [err212];
}
else {
vErrors.push(err212);
}
errors++;
}
if(data126.nodeCount === undefined){
const err213 = {instancePath:instancePath+"/integrity",schemaPath:"urn:cogo:v4:document-model/properties/integrity/required",keyword:"required",params:{missingProperty: "nodeCount"},message:"must have required property '"+"nodeCount"+"'"};
if(vErrors === null){
vErrors = [err213];
}
else {
vErrors.push(err213);
}
errors++;
}
if(data126.documentModelSha256 !== undefined){
let data127 = data126.documentModelSha256;
if(typeof data127 === "string"){
if(!pattern5.test(data127)){
const err214 = {instancePath:instancePath+"/integrity/documentModelSha256",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/documentModelSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err214];
}
else {
vErrors.push(err214);
}
errors++;
}
}
else {
const err215 = {instancePath:instancePath+"/integrity/documentModelSha256",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/documentModelSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err215];
}
else {
vErrors.push(err215);
}
errors++;
}
}
if(data126.sourceLayoutGraphSha256 !== undefined){
let data128 = data126.sourceLayoutGraphSha256;
if(typeof data128 === "string"){
if(!pattern5.test(data128)){
const err216 = {instancePath:instancePath+"/integrity/sourceLayoutGraphSha256",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/sourceLayoutGraphSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err216];
}
else {
vErrors.push(err216);
}
errors++;
}
}
else {
const err217 = {instancePath:instancePath+"/integrity/sourceLayoutGraphSha256",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/sourceLayoutGraphSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err217];
}
else {
vErrors.push(err217);
}
errors++;
}
}
if(data126.layoutGraphSha256 !== undefined){
let data129 = data126.layoutGraphSha256;
if(typeof data129 === "string"){
if(!pattern5.test(data129)){
const err218 = {instancePath:instancePath+"/integrity/layoutGraphSha256",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/layoutGraphSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err218];
}
else {
vErrors.push(err218);
}
errors++;
}
}
else {
const err219 = {instancePath:instancePath+"/integrity/layoutGraphSha256",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/layoutGraphSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err219];
}
else {
vErrors.push(err219);
}
errors++;
}
}
if(data126.pageCount !== undefined){
let data130 = data126.pageCount;
if(!(((typeof data130 == "number") && (!(data130 % 1) && !isNaN(data130))) && (isFinite(data130)))){
const err220 = {instancePath:instancePath+"/integrity/pageCount",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/pageCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err220];
}
else {
vErrors.push(err220);
}
errors++;
}
if((typeof data130 == "number") && (isFinite(data130))){
if(data130 < 1 || isNaN(data130)){
const err221 = {instancePath:instancePath+"/integrity/pageCount",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/pageCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err221];
}
else {
vErrors.push(err221);
}
errors++;
}
}
}
if(data126.nodeCount !== undefined){
let data131 = data126.nodeCount;
if(!(((typeof data131 == "number") && (!(data131 % 1) && !isNaN(data131))) && (isFinite(data131)))){
const err222 = {instancePath:instancePath+"/integrity/nodeCount",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/nodeCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err222];
}
else {
vErrors.push(err222);
}
errors++;
}
if((typeof data131 == "number") && (isFinite(data131))){
if(data131 < 0 || isNaN(data131)){
const err223 = {instancePath:instancePath+"/integrity/nodeCount",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/nodeCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err223];
}
else {
vErrors.push(err223);
}
errors++;
}
}
}
if(data126.resourceCount !== undefined){
let data132 = data126.resourceCount;
if(!(((typeof data132 == "number") && (!(data132 % 1) && !isNaN(data132))) && (isFinite(data132)))){
const err224 = {instancePath:instancePath+"/integrity/resourceCount",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/resourceCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err224];
}
else {
vErrors.push(err224);
}
errors++;
}
if((typeof data132 == "number") && (isFinite(data132))){
if(data132 < 0 || isNaN(data132)){
const err225 = {instancePath:instancePath+"/integrity/resourceCount",schemaPath:"urn:cogo:v4:document-model/properties/integrity/properties/resourceCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err225];
}
else {
vErrors.push(err225);
}
errors++;
}
}
}
}
else {
const err226 = {instancePath:instancePath+"/integrity",schemaPath:"urn:cogo:v4:document-model/properties/integrity/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err226];
}
else {
vErrors.push(err226);
}
errors++;
}
}
}
else {
const err227 = {instancePath,schemaPath:"urn:cogo:v4:document-model/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err227];
}
else {
vErrors.push(err227);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.pages !== undefined){
let data133 = data.pages;
if(Array.isArray(data133)){
const len12 = data133.length;
for(let i12=0; i12<len12; i12++){
let data134 = data133[i12];
if(data134 && typeof data134 == "object" && !Array.isArray(data134)){
if(data134.nodes !== undefined){
let data135 = data134.nodes;
if(Array.isArray(data135)){
const len13 = data135.length;
for(let i13=0; i13<len13; i13++){
let data136 = data135[i13];
const _errs294 = errors;
let valid52 = false;
let passing0 = null;
const _errs295 = errors;
if(!(validate21(data136, {instancePath:instancePath+"/pages/" + i12+"/nodes/" + i13,parentData:data135,parentDataProperty:i13,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
var _valid0 = _errs295 === errors;
if(_valid0){
valid52 = true;
passing0 = 0;
var props0 = true;
}
const _errs296 = errors;
if(!(validate27(data136, {instancePath:instancePath+"/pages/" + i12+"/nodes/" + i13,parentData:data135,parentDataProperty:i13,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
errors = vErrors.length;
}
var _valid0 = _errs296 === errors;
if(_valid0 && valid52){
valid52 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid52 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs297 = errors;
if(!(validate31(data136, {instancePath:instancePath+"/pages/" + i12+"/nodes/" + i13,parentData:data135,parentDataProperty:i13,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
errors = vErrors.length;
}
var _valid0 = _errs297 === errors;
if(_valid0 && valid52){
valid52 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid52 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
const _errs298 = errors;
if(!(validate37(data136, {instancePath:instancePath+"/pages/" + i12+"/nodes/" + i13,parentData:data135,parentDataProperty:i13,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate37.errors : vErrors.concat(validate37.errors);
errors = vErrors.length;
}
var _valid0 = _errs298 === errors;
if(_valid0 && valid52){
valid52 = false;
passing0 = [passing0, 3];
}
else {
if(_valid0){
valid52 = true;
passing0 = 3;
if(props0 !== true){
props0 = true;
}
}
const _errs299 = errors;
if(!(validate40(data136, {instancePath:instancePath+"/pages/" + i12+"/nodes/" + i13,parentData:data135,parentDataProperty:i13,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate40.errors : vErrors.concat(validate40.errors);
errors = vErrors.length;
}
var _valid0 = _errs299 === errors;
if(_valid0 && valid52){
valid52 = false;
passing0 = [passing0, 4];
}
else {
if(_valid0){
valid52 = true;
passing0 = 4;
if(props0 !== true){
props0 = true;
}
}
const _errs300 = errors;
if(!(validate44(data136, {instancePath:instancePath+"/pages/" + i12+"/nodes/" + i13,parentData:data135,parentDataProperty:i13,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
errors = vErrors.length;
}
var _valid0 = _errs300 === errors;
if(_valid0 && valid52){
valid52 = false;
passing0 = [passing0, 5];
}
else {
if(_valid0){
valid52 = true;
passing0 = 5;
if(props0 !== true){
props0 = true;
}
}
}
}
}
}
}
if(!valid52){
const err228 = {instancePath:instancePath+"/pages/" + i12+"/nodes/" + i13,schemaPath:"#/allOf/1/properties/pages/items/properties/nodes/items/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err228];
}
else {
vErrors.push(err228);
}
errors++;
}
else {
errors = _errs294;
if(vErrors !== null){
if(_errs294){
vErrors.length = _errs294;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err229 = {instancePath:instancePath+"/pages/" + i12+"/nodes",schemaPath:"#/allOf/1/properties/pages/items/properties/nodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err229];
}
else {
vErrors.push(err229);
}
errors++;
}
}
}
else {
const err230 = {instancePath:instancePath+"/pages/" + i12,schemaPath:"#/allOf/1/properties/pages/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err230];
}
else {
vErrors.push(err230);
}
errors++;
}
}
}
else {
const err231 = {instancePath:instancePath+"/pages",schemaPath:"#/allOf/1/properties/pages/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err231];
}
else {
vErrors.push(err231);
}
errors++;
}
}
}
else {
const err232 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err232];
}
else {
vErrors.push(err232);
}
errors++;
}
validate20.errors = vErrors;
return errors === 0;
}
validate20.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};
